const newsList = [
    {
        imgPo: "imgLeft", // 图片的位置，左或者右
        en: true, // 是否有英文翻译
        img: require("@/assets/img/news/20200229/1.png"), // 封面图
        title: '[Xinhua News Agency] We Worried About "Difficult" But not Afraid of "Difficult"', // 标题
        time: "2020.02.29", // 时间
        // desc: '主要研发、生产虹膜识别技术产品的企业“虹星科技”也在抗击疫情中寻找新的创新应用。', // 封面描述
        desc:
            "Reporter of Xinhua News Agency: Gai Boming and Ma Yan., During the outbreak of new crown pneumonia,  China’s SME was affected. In Beijing, some science and technology enterprises,on the one hand, use their own technology to continue export innovation power for the war of “epidemic”; on the other hand, these entrepreneurs these entrepreneurs, who are themselves scientists,use innovation to achieve their own sustainable development.",
        content: [
            {
                type: "title",
                inner: "《新华社》记者盖博铭、马岩",
            },
            {
                type: "text",
                inner:
                    "新冠肺炎疫情期间，中小微企业的正常经营受到一定影响。在北京，一些科创企业一方面利用自身技术为战“疫”持续输出创新力；另一方面，这些本身就是科技工作者的创业者们用创新实现自身的可持续发展。",
            },
            {
                type: "text",
                inner: "记者近日走近这些“科学企业家”们，感受他们复工以来的战“疫”心得。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20200229/1.png"),
                size: "",
                desc: "2月23日，“虹星科技”创始人侯广琦讲解虹膜识别产品技术创新。新华社发",
            },
            {
                type: "text",
                fontWeight: "bold",
                inner: "“都出来创业了还怕啥难”",
            },
            {
                type: "text",
                inner:
                    "主要研发、生产虹膜识别技术产品的企业“虹星科技”也在抗击疫情中寻找新的创新应用。",
            },
            {
                type: "text",
                inner:
                    "创始人侯广琦是中国光学学会会员。“虹膜特征对大规模流动人群识别更加精准，这项技术在疫情预防和防控期间有望发挥更大作用。”侯广琦说。",
            },
            {
                type: "text",
                inner:
                    "疫情发生后，“虹星科技”对其一款热门虹膜识别产品进行改进，加装远距离红外测温仪，迅速得到学校、医院、工厂等30多家单位的采购意向，二月底可正式对外供货。",
            },
            {
                type: "text",
                inner:
                    "“目前，我们产品的需求量已超过去年全年。”侯广琦说，“疫情对我们销售人员出京、供应链稳定等带来一定影响，但这也给虹膜识别技术的推广创造新机会。”",
            },
            {
                type: "text",
                inner:
                    "对于“带着技术下海”的科技工作者来说，创业意味着离开相对稳定的生活。“我们要克服困难、寻找机会。”侯广琦说，一些问题用老方法不好解决，就需要理念创新、技术创新和模式创新。",
            },
            {
                type: "text",
                inner: "“困难肯定不怕，怕就不出来创业了。”侯广琦说，我们对未来依然充满信心。",
            },
        ],
    },
    {
        imgPo: "imgLeft", // 图片的位置，左或者右
        en: true, // 是否有英文翻译
        img: require("@/assets/img/news/20200109/2.png"), // 封面图
        title: "[36 Kr] IriStar Received Tens of Millions in Pre-A Round Financing", // 标题
        time: "2020.01.09", // 时间
        desc:
            "36 Kr learn, Long distance iris recognition product provider 「IriStar」has completed Pre-A round financing which was funded by Zhongkehaichuang and Ally Capital. IriStar was incubated in academician Tan Tieniu's Team of Institute of automation, Chinese Academy of Sciences. The financing will be mainly used for R&D investment, product updating, continuous deepening of supply chain and warehouse system, and improving reserve of talents, so as to accelerate the development and application in various industries.", // 封面描述
        content: [
            {
                type: "text",
                inner:
                    "36氪获悉，远距离虹膜识别产品提供商「虹星科技」已完成Pre A轮融资，本轮融资来自于中科海创和曦域资本。公司孵化于中科院自动化所谭铁牛院士团队，融资将主要用于研发投入、产品打磨，供应链和仓配体系的持续深耕及完善人才储备等方面，加速在各行业的拓展和落地应用。",
            },
            {
                type: "text",
                inner:
                    "生物识别技术作为替代传统密码进行身份验证的有效方式，已经在信息技术、金融交易、社会安全等领域显示出巨大的产业潜力。根据IBG前瞻产业研究院统计，中国生物识别行业市场规模将在2021年超过340亿元。",
            },
            {
                type: "text",
                inner:
                    "虹膜识别是近年来出现的新兴识别技术，与其它识别技术相比，具备非接触性、唯一性、防伪性、稳定性的特点，是目前被认为的除了DNA之外的最精确可靠的生物识别技术。",
            },
            {
                type: "text",
                inner:
                    "虹膜识别的技术壁垒很高，主要在于近距离虹膜识别应用难度高、场景受限，目前行业内主要产品识别距离大多在25cm-40cm 。虹星科技实现的行业突破在于：公司自主研发的远距离虹膜人脸融合识别产品工作距离可达到1.2m，并且在2s内精准完成人员身份无感识别，其技术入选《科技日报》“2018年中国十大突破技术”。此外，公司研发的“行进中虹膜识别技术”已完成实验测试，目前实际场景验证中，其最远工作距离可达10m。",
            },
            {
                type: "text",
                inner:
                    "虹星科技总经理侯广琦表示，区别于单一的人脸识别技术，虹星科技将人脸与远距离虹膜识别技术融合的原因在于：",
            },
            {
                type: "text",
                inner:
                    "当前普及的人脸识别技术能够实现的年龄跨度较小，只有5年，并且系统可识别的最大人群规模只在1万左右，也难以解决双胞胎的识别问题。相比之下，虹膜自胎儿发育阶段形成后直至死亡终生不变，具有极强的稳定性，决定了身份识别的唯一性，且系统可识别的最大人群规模为百万到十亿量级，无论是适用人群规模还是精度比人脸高很多。因此，虹膜人脸融合识别结合了人脸识别的“便利性”和虹膜识别的“精准性”，既可以普及到现有的人脸识别市场，还可以改善人脸识别原有的弊端，是对现有人脸识别技术的重大升级。",
            },
            {
                type: "text",
                inner:
                    "36氪此前曾对虹星科技做过详细报道，公司将产品定位在人脸识别适用的场景，搭配精确度更高的虹膜识别技术，组成多模态识别产品，目前已落地安防、司法、交通、社区等领域。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20200109/1.jpg"),
                size: "medium",
                desc: "",
            },
            {
                type: "text",
                inner:
                    "公司总经理侯广琦告诉36氪，虹星科技2019年主要的业务变化在于：由最开始的单一产品销售，目前已经向十几个行业输出了解决方案，平均客单价百万级。公司根据行业中不同类型的使用群体配置相应的识别设备，将系统连接起来对接到客户的业务系统，还可以实现分时、分区的识别，比如白天人流量大就选用人脸识别，在权限等级高或者夜晚需要精确度高的场景中就切换成虹膜识别，能够快速接入现有各类业务平台。",
            },
            {
                type: "text",
                inner:
                    "除了提供行业解决方案，虹星科技还销售虹膜识别产品、模组。据悉，公司2019年营收是去年的400%以上。",
            },
            {
                type: "text",
                inner:
                    "与市场上其他做生物识别的公司相比，虹星科技突出的优势在于：公司的芯片、传感器、光学镜头等核心部件都是自己开发。基于这样的基础，公司将业务扩展到工业视觉领域，目前已经研发出PCB AI服务器，针对印刷电路板裸板生产出来后的检测环节，帮助提高检测精准度，减少人工复检，目前已经能够降低50%以上误报率。客户面向PC厂商，每台约十几万元，目前已进入多家上市公司。",
            },
            {
                type: "text",
                inner:
                    "关于资方观点——中科海创总经理孙健波：“我们中科海创作为国家科技成果转化创投子基金，非常重视创业企业的基础研发能力和应用转化能力。虹星科技的技术源自于中科院自动化所，在生物识别领域有很深的积淀。其远距离虹膜技术和虹膜人脸融合的产品，在国内虹膜行业居于领先地位。我们认为虹膜识别正处于产业爆发的前夜，也非常看好虹星在这个过程中所扮演的重要角色。虹星科技有着一支技术研发能力强、产品化和市场化认知明确的团队，在过去的一年也取得了明显的进展。”",
            },
            {
                type: "text",
                inner:
                    "曦域资本创始合伙人黄晓黎：虹膜做为生物识别的特征之一，具有唯一性、精准度高、稳定性高、无需侵入等优势，曦域长期看好公司核心远距离虹膜+人脸识别、光场等基础技术在安防、金融、工业视觉等领域的广泛应用趋势，并选择持续加投。在曦域2017年10月投资公司天使轮至今的两年，公司完成了从科研院所团队到商业化公司的蜕变，在市场、行业拓展方面发展迅速。",
            },
        ],
    },
    {
        imgPo: "imgLeft", // 图片的位置，左或者右
        en: true, // 是否有英文翻译
        img: require("@/assets/img/news/201911280900/2.png"), // 封面图
        title:
            'IriStar Has Won The Top Ten Outstanding Innovation Awards of "Gazelle Enterprises".', // 标题
        time: "2019.11.28", // 时间
        desc:
            "On Nov. 20th , sponsored by tianjin science and technology bureau and organized by tianjin science and technology financing holding group co., LTD,The news conference of the first batch “Young Eagles and Gazelles Enterprises” was held in Tianjin. Deputy mayor of Tianjin (Lin Maoqing) and district government leaders attended the meeting.", // 封面描述
        content: [
            {
                type: "text",
                inner:
                    "11月20日，由天津市科学技术局主办，天津科技融资控股集团有限公司承办的天津市首批雏鹰、瞪羚企业发布会在天津召开，天津市副市长连茂君及各区政府分管领导等参会。",
            },
            {
                type: "text",
                inner:
                    "发布会上，包括虹星科技在内的10家企业获得全市瞪羚企业“卓越创新奖”。会议还邀请了5家雏鹰、瞪羚企业代表，就如何通过技术创新、模式创新、协同创新加速企业能级提升，分享创业经验。虹星科技首席技术官李海青博士作为企业家代表向到场领导、友商、金融机构与媒体代表探讨分享了虹星科技在多应用场景下的虹膜人脸融合识别解决方案，如何助力构建更加精准、高效、安全的智慧城市建设网络。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201911280900/1.png"),
                desc: "天津市副市长连茂君致辞发言",
            },
            {
                type: "text",
                inner:
                    "李海青博士在会上介绍，目前主流生物特征识别的安全风险主要来自六个方面，针对识别算法后台的攻击、针对身份认证方案的攻击、针对活体检测的呈现攻击、针对个人的信息数据窃取、针对身份识别的呈现攻击与针对前端设备的综合攻击。尽管当前人脸识别终端推广力度大，但在便利性占据优势的人脸识别模组，却存在活体检测组件效果不佳、抗呈现攻击能力差的隐患。此外，在人脸数据方面，也存在元数据或特征数据的存储缺乏安全保护，数据传输缺乏保护的情况。针对目前生物特征识别市场严峻的安全保护形势，李海青博士认为，中远距离虹膜+人脸融合识别的方案特别适合保障身份识别安全。",
            },
            {
                type: "text",
                inner:
                    "作为远距离虹膜+人脸融合识别的领跑者，虹星科技掌握国际领先的活体检测技术，首创虹膜+人脸的双重活体检测，在假体攻击数据集测试中取得了显著的性能提升。虹星科技利用近红外光与可见光的辅助，获取多光谱信息，并组建多摄像头矩阵，探索三维深度信息。虹星科技采用的多摄+TOF镜头，可更精准、更深度进行高效活体检测，捕获人脸三维深度信息，并实时同步记录。此外，虹星还为活体检测设置了深度传感器，建立一个完整的反欺骗干扰系统部署，能在复杂环境下拥有极佳的假体识别表现。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201911280900/2.png"),
                desc: "虹星科技获评十佳“卓越创新奖”瞪羚企业",
            },
            {
                type: "text",
                inner:
                    "在保护生物信息数据安全方面，虹星科技也制定了一套强有力的基于密码学的原始图像和特征模板保护方案，利用数据加密手段将密钥和图像/特征信息相绑定，生成密文进行传输，在起到隐私数据保护的目的，对虹膜数据进行安全性保护，以满足用户在身份采集、存储和认证过程中对隐私保护的安全性需求，成为保障公民隐私最坚实的一道防火墙，严守人体生物密码的安全防线。+人脸融合识别的方案特别适合保障身份识别安全。",
            },
            {
                type: "text",
                inner:
                    "最后，李海青博士也对多模态生物识别模式的未来发展进行了展望，基于目前监管的要求，李海青博士认为，在复杂多变的网络空间仅依靠人脸等单一特征进行身份验证识别，存在一定的安全隐患，且随着技术进步，可对亿级大规模人群进行1：N的身份识别手段目前仍以虹膜识别为最优选，所以，远距离虹膜人脸融合识别将会是未来不可或缺的主流生物识别手段之一。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201911280900/3.png"),
                desc: "虹星首席技术官李海青博士分享企业技术创新经验",
            },
            {
                type: "text",
                inner:
                    "据了解，今年5月30日天津市政府启动实施《天津市创新型企业领军计划》，聚焦人工智能、生物医药、新能源新材料等战略性新兴产业，强化企业创新主体地位，建立“雏鹰—瞪羚—科技领军”企业梯度扶持体系，大力推动新技术、新产业、新业态、新模式“四新经济”发展，扎实推动创新型企业发展，打造“科企3.0版”，引领、辐射、带动产业高质量发展。",
            },
            {
                type: "text",
                inner:
                    "天津市科技局有关负责人表示，天津市财政将对首次评价入库的瞪羚企业给予一次性最高20万元奖励，同时还将对此批瞪羚企业实施动态管理和分类精准支持，给予贷款贴息、认定奖励等支持，滨海新区还将瞪羚企业产品纳入国有企业、事业单位采购目录等专项支持。",
            },
        ],
    },
    {
        imgPo: "imgLeft",
        en: true, // 是否有英文翻译
        img: require("@/assets/img/news/201911210900/1.jpg"),
        title: "IriStar was Invited to the 11th SSCIA Summit on Smart City Summit",
        time: "2019.11.21",
        desc:
            "Dr. Hou Guangqi as a general manager of IriStar, scientific and technological achievements industrialization team, Institute of automation, Chinese Academy of Sciences was invited to SSCIA summit on Oct.30th. Dr. Hou discussed the new security opportunities created by long-distance iris face fusion recognition in smart city, described the layout and blueprint of IriStar in construction of smart city, and interpreted the new growth dividend of smart security multi-modal identification represented by iris face fusion recognition under intelligent security.",
        content: [
            {
                type: "text",
                inner:
                    "2019年10月31日，为期四天的第十七届中国国际社会公共安全博览会（以下简称“安博会”)落下帷幕。值得一提的是，10月30日，中科院自动化所科技成果产业化团队虹星科技总经理侯广琦博士受邀第十一届SSCIA智慧城市高峰会，畅谈远距离虹膜人脸融合识别创造的智慧城市安防新机遇，描绘虹星在智慧城市安防建设中的布局与蓝图，并对智慧安防下以虹膜人脸融合识别为代表的多模态生物识别迎来爆发式增长的新红利。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201911210900/1.jpg"),
                desc: "虹星科技创始人侯广琦博士在安博会SSCIA高峰论坛上发表报告",
            },
            {
                type: "title",
                inner: "面部多模态识别：智慧安防发展的硬性需求与必然趋势",
            },
            {
                type: "text",
                inner:
                    "伴随着大数据、移动云联网和人工智能技术的不断进步，全球掀起了一波“智慧城市”建设发展的新浪潮，国内近年更是大动作不断，已然成为拥抱浪潮的主力军。据统计，中国83%的地级市，总计超过500座城市正在建设智慧城市，已建成项目已突破350个。安防行业作为智慧城市的安全之门，担负着智慧城市中智慧交通、智慧金融、智慧社区等多个系统视频图像识别的“智慧之眼”。随着智慧城市项目不断落地以及智能化要求提高，基于日益扩展的城市规模和治理难度，城市安防体控就成为智慧城市系统当中的重中之重。",
            },
            {
                type: "text",
                inner:
                    "现如今，国内的智慧城市发展已经达到国际先进水平，纵观国内安防领域，依然面临着严峻复杂的形势和不断出现的新状况：基层治安防范薄弱，关键信息埋没于海量数据，身份信息安全受到威胁，即便用上花招百出、纷繁复杂的各式身份认证手段，伪装、盗用、冒用身份事故仍然屡见不鲜。精准识别与深度防伪成为当今和未来智慧城市安全管理的关键技术要求，面部多模态的精准识别是智慧城市发展的硬性需求与必然趋势，也是智慧城市高速增长的下一个红利所在。",
            },
            {
                type: "title",
                inner: "远距离虹膜人脸融合：大规模人群识别与大数据精准分析最优选",
            },
            {
                type: "text",
                inner:
                    "侯广琦博士在高峰会上指出，随着社会人口流动性加强、特殊人群增多，传统的人口管理模式亟待重构。虽然随着“十三五”规划下雪亮工程的建设部署，城市中安装部署大量视频监控，数字化建设成效显著，但剧增的监控数据和生成数据，让处理维度大幅度增高，精准分析迫在眉睫。虹星科技的远距离虹膜人脸融合识别技术，则能精准满足大规模人群识别与精准分析的硬需求，改变海量数据实现服务器存储，却无法造福于人的尴尬处境，真正做到安防信息围绕生物活体，利用虹膜人脸融合识别，在出入口实现个人身份验证及信息的流通。",
            },
            {
                type: "text",
                inner:
                    "虹星科技在本次论坛发布的这套智慧城市建设智能识别体系包括了生物特征信息采集设备、生物特征识别设备、虹膜识别模组和虹膜身份管理平台，可以满足不同场景的落地需求。虹星科技可通过智能人机三维交互以及远距离虹膜人脸融合识别技术，打造产品矩阵组成整体解决方案，包括W200手持式虹膜人脸信息采集设备、S300-UC桌面式虹膜人脸信息采集设备、S320壁挂式混合生物特征识别一体机、S200G系列“虹膜识别+活体检测+人证 比对”三合一智能闸机、S200混合生物特征识别一体机、S260P驾驶员身份识别一体机等在内，可应用于智慧校园、智慧边检、智慧工地、智慧消防、智慧车站、智慧医疗，为构建安全精准高效智慧城市防护网提供了完美解决方案。",
            },
            {
                type: "text",
                inner:
                    "以智慧园区安防系统为例，通过虹星科技自主研发的S260P驾驶员身份识别一体机、S200G混合生物识别智能闸机、W200手持式虹膜人脸信息采集设备与原有监控体系的融合，利用高性能的身份识别系统和设备将原有监控系统智能化全面提升，打造出24小时园区智能安全防护系统。在原有设施基础上，也可结合虹星的智慧园区解决方案，对园区门口、楼宇门口以及楼宇内部进行升级，实现三层人员管控系统。第一层为在园区门口进行身份鉴定，通过S260P识别监控来往车辆和人员，内部员工出入口在通行高峰期采用车牌识别+人脸识别，非峰段期间采用车牌识别+虹膜识别，外来访客出入口则严格采用车牌识别+虹膜识别的模式，在保证园区安全的同时大幅提升通行速率。人员通行入口亦是同理，使用S200G混合生物识别智能闸机，灵活运用生物特征管控人员出入，提高系统效率。第二层为通过S200G在楼宇门口开展身份识别。第三层为在楼宇内部对现有监控系统智能化改造，实现非受控人脸识别功能，不但可以记录非授权员工运动轨迹，更能识别陌生访客并实时预警，大大提高了园区安全系数。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201911210900/2.jpg"),
                desc: "侯广琦博士在论坛上解读智慧安防多模态识别增长新红利",
            },
            {
                type: "title",
                inner: "以民族自主研发实力开创智能安防新篇章",
            },
            {
                type: "text",
                inner:
                    "虹星科技作为国立科研机构进行国产自主可控知识产权研发的典型产业化案例，是中国科学院自动化研究所在人工智能领域孵化的高科技企业，其核心团队源自国家重点实验室的生物特征识别科研团队，是迄今国内规模最大人数最多的远距离虹膜识别研究和开发团队，拥有10年远距离虹膜识别应用深耕经验，15年视觉成像处理研发管理和实践基础，旗下拥有虹膜人脸采集注册、中远距离虹膜人脸融合等一系列多模态生物特征识别产品及工业视觉产品。",
            },
            {
                type: "text",
                inner:
                    "在历经了两代设备迭代之后，虹星团队目前已实现了虹膜设备成本的可控，其产品性能上对标欧美同业最高水平，但成本却是国外同类产品的1/6到1/8，是全球少数几家掌握了虹膜识别核心算法的企事业单位之一。虹星科技2018年在虹膜识别技术领域实现了重大突破，公司的远距离虹膜技术入选《科技日报》2018年国内十大技术突破。",
            },
            {
                type: "text",
                inner:
                    "在活体检测技术潜心钻研已久的虹星科技，首创虹膜+人脸的双重活体检测技术，并将虹膜识别设备的小型化做到了极致。在发展过程中，虹星科技不断加大自主研发力度，优化算法、硬件与软件，立志为用户提供优质的服务体验；为方便用户使用，提高产品服务流畅度，虹星科技与多行业机构合作，确保安全性和可靠性；在精细制造的基础上，不断提升对质量和品牌概念的重视。",
            },
            {
                type: "text",
                inner:
                    "脱胎于中科院自动化所，承载着中国高精尖技术产业化、民族自主自强的历史使命，背负着将前沿科技推向公民生活、造福人类的责任感，已深深渗透到虹星科技的骨髓与血液中。产业报国、科技报国，是虹星科技矢志不渝的使命。未来，以科技创新为第一驱动力的虹星科技，定将依靠国产自主研发企业磅礴的力量和最大的底气，用多模态识别技术产品的发展为未来的智能安防打开新的窗口、创造新的可能。",
            },
        ],
    },
    {
        imgPo: "imgLeft",
        en: true, // 是否有英文翻译
        img: require("@/assets/img/news/20191118/1.jpg"),
        title:
            "IriStar was Selected as the First Group of “Gazelle Enterprises” in Tianjin in 2019",
        time: "2019.11.18",
        desc:
            "On Nov. 6th, 2019,in Tianjin first batch of gazelle enterprises list announce to the whole city. Tianjin IriStar Co.,Ltd. (hereinafter referred to as IriStar) was listed in the first batch of gazelle enterprises from more than one thousand candidates, for Institute of automation, Chinese Academy of Sciences the solid research background and its own strong technical development capability.",
        content: [
            {
                type: "text",
                inner:
                    "2019年11月6日，天津市2019年首批瞪羚企业入库名单向全市公布，天津中科虹星科技有限公司（以下简称虹星科技）凭借中科院自动化所扎实的研发背景及自身过硬的技术开发能力，从千余家竞选企业中脱颖而出，最终入选首批瞪羚企业名单。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20191118/1.jpg"),
                desc: "虹星科技入选天津2019首批瞪羚企业名单",
            },
            {
                type: "text",
                inner:
                    "“瞪羚计划”作为天津市实施创新驱动发展战略、建设国家自主创新示范区的一项重要举措，旨在遴选并培育一批成长速度快、经济效益好、创新能力强、发展潜力大的“瞪羚企业”进行重点支持，积极引导其走高质量、高效益、可持续的发展道路，成为高新技术产业的生力军。",
            },
            {
                type: "text",
                inner:
                    "虹星科技身为中科院自动化所科研成果产业化所孵化的一家年轻的高科技公司，能从千余家实力强劲的企业中突出重围，跻身入选的瞪羚企业名单，代表虹星的企业科技创新、持续成长能力得到了政府部门的高度认可。公司从成立之初时的十余人研发团队，迅速成长为以创新驱动为第一生产力，集研发、产品、市场、营销于一体的全自主创新高科技企业，在团队10年远距离虹膜识别的应用经验上予以深耕，同时坚持在15年视觉成像处理研发管理和实践基础上不断开拓创新，在产品上高举代表前沿方向的虹膜人脸融合的多模态面部采集识别模式不动摇，成长为一家专注于计算机视觉成像且掌握前沿核心技术的技术领跑型企业，更在2018年入选《科技日报》的“2018年中国十大突破技术”。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20191118/2.jpg"),
                desc: "虹星科技中远距离虹膜人脸融合识别产品",
            },
            {
                type: "text",
                inner:
                    "虹星科技在产品算法研发上投入了大量成本与精力，在过去两年中共研制出十余款产品，包括S200系列远距离虹膜人脸融合识别设备、S260P驾驶员识别设备、S320壁挂式虹膜人脸识别设备、U100桌面USB识别设备、W200虹膜人脸采集设备及S300-UC桌面式虹膜人脸信息采集设备等，于多个行业进行全方位的市场布局，在港口出入境、机场、智能机器人、教育装备、社区园区门禁、智慧工地、保密箱柜等领域均有业务涉及，深受业界好评。",
            },
            {
                type: "text",
                inner:
                    "虹星科技此次入选天津市瞪羚企业后，将充分利用“瞪羚企业”享受的科技金融政策，如瞪羚般快速奔跑，持续成长，进一步扩大行业内的领先优势，跳的更高、跑的更快，实现新的跨越式发展。",
            },
            {
                type: "text",
                inner:
                    "可以预见，未来几年虹膜市场将会迎来一次突破性的发展，虹星科技作为远距离虹膜人脸融合识别开创者与领导者，必将紧抓这次市场机遇，加强核心技术攻关，做出识别速度更快、识别精度更高、受环境因素影响更小、用户体验度更好的顶尖优质产品，为全社会身份识别推广发展与国家科技创新助力添彩。",
            },
        ],
    },
    {
        imgPo: "imgLeft",
        en: false, // 是否有英文翻译
        img: require("@/assets/img/news/20191107/1.jpg"),
        title: "2019深圳安博会人气之星 虹星科技面部多模态识别引领智能安防",
        time: "2019.11.07",
        desc:
            "10月28日，第十七届中国国际社会公共安全博览会(CPSE，以下简称“深圳安博会”)于深圳揭开帷幕。作为全球最权威、最具影响力的智能安防展览会之一，本届安博会聚焦人工智能、大数据、智慧安防、智慧城市等，吸引了全球超过1100家安防厂商参展，向世界展示中国安防科技的实力，展会首日观展人数便高达数万人次。",
        content: [
            {
                type: "text",
                inner:
                    "10月28日，第十七届中国国际社会公共安全博览会(CPSE，以下简称“深圳安博会”)于深圳揭开帷幕。作为全球最权威、最具影响力的智能安防展览会之一，本届安博会聚焦人工智能、大数据、智慧安防、智慧城市等，吸引了全球超过1100家安防厂商参展，向世界展示中国安防科技的实力，展会首日观展人数便高达数万人次。",
            },
            {
                type: "text",
                inner:
                    "截至2019年，深圳安博会已成功举办30年，旨在为世界呈现前沿人工智能、大数据、智慧安防等科技产品。伴随着全球安防产业的快速发展，深圳安博会已经成为全球优质安防企业聚合地，能否在现场抢占优质展位也成为衡量安防企业品牌知名度与市场占有率的标志。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20191107/1.jpg"),
                desc: "虹星科技展台圈粉 面部多模态识别产品成人气明星",
            },
            {
                type: "text",
                inner:
                    "位于六号国际馆6C04展位的虹星科技可谓此次安博会的流量担当，人流汇聚能力一时无两：一凭虹星科技的“高颜值”展台，坐镇大批观众通行出入安博会的出入口，占据了地利；二靠虹星抢眼的虹膜+人脸面部多模态识别设备，快速准确的识别效果引人啧啧惊叹，亮出了法宝；三有近似复制粘贴的双胞胎充当演示模特，现场展示一秒辨姐妹，吸睛指数爆表，致使虹星展台开展首日便人头攒动。",
            },
            {
                type: "text",
                inner:
                    "实力圈粉的虹星科技展台前人潮汹涌，出于好奇想亲身体验的普通观众与前来咨询业务的客户交织成密集的人流，更好几次因大批驻足不前的参展者滞留，将一旁的行走通道堵得水泄不通。虹星的接待人员也是分身乏术，一不留神就被四五个提问和咨询的参展人士团团围住，嗓子在好几日不间断的讲解下也显露几分干哑与疲态，但为客户悉心讲解的耐心未曾下线。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20191107/2.jpg"),
                desc: "一秒识别双胞胎身份，拒绝假体攻击获观众赞叹",
            },
            {
                type: "text",
                inner:
                    "现场体验虹星产品的观众，都对虹星展出的产品矩阵表现出了浓厚兴趣，除了W200和S300-U这两款入选相关部门《虹膜数据采集终端合格产品及制造商名录》虹膜人脸采集设备之外，S200P混合生物特征识别一体机、S260P驾驶员身份识别一体机、S200G混合生物特征识别智能闸机、S300-KQ虹膜人脸识别一体化模组等一众设备组成了整体解决方案无一不让在场的观众留下深刻的印象。",
            },
            {
                type: "text",
                inner:
                    "不少上手体验过虹星产品的参展者表示，通过W200注册虹膜人脸信息，便可以实现全场设备的互联，高效精准且方便快捷的识别体验，让人充分感受到了面部多模态识别技术的魅力。像S300-UC这样的小型化桌面识别设备，个头看似不大，却可以达到很多大型设备都无法实现的识别效果，这种未来化的场景相当梦幻。还有观众表示，在他以往认知中的生物识别产品，只能通过人脸显著的外貌特征来区别身份，或进行简单的一对一的身份验证功能，而像同卵双胞胎相似处过多的人群，是无法正确区分其身份的，而在虹星展台见识到的虹膜人脸识别设备，可在1秒内识别双胞胎身份，才让他领略到虹膜人脸融合技术在精准识别上的独特优势。",
            },
            {
                type: "text",
                inner:
                    "听闻虹星科技前沿的虹膜+人脸双重活体检测技术，有部分现场观众更尝试用手机照片、打印图片等方式对虹星产品发起了假体识别挑战，但无一成功，虹星科技凭借首创式双重活体检测技术，利用近红外光与可见光的辅助探索三维深度信息，将假体攻击拒之门外，高安全的高性能表现也获得了围观人群的交口称赞。",
            },
            {
                type: "text",
                inner:
                    "目前，虹星科技已与金融、互联网、零售、教育、房地产等行业建立合作关系，并在智慧工地、通关边检、智慧社区等落地项目中投入使用。本次虹星科技在2019深圳安博会上的亮眼表现，也昭示着虹膜人脸融合识别技术的商业化道路有着广阔的未来蓝海。虹星作为中远距离虹膜人脸融合识别领导者，必将在未来国内安防市场中占据一席之地，我们期待虹星科技在更多场景和应用中乘风破浪，绽放出更耀眼的光芒！",
            },
        ],
    },
    {
        imgPo: "imgLeft",
        en: false, // 是否有英文翻译
        img: require("@/assets/img/news/20191031/1.jpg"),
        title: "2019安博会|虹星科技如何深度布局虹膜人脸识别市场？",
        time: "2019.10.31",
        desc:
            "身份识别技术一直是人类长期研究的重要课题。伴随着人工智能技术的发展，掌纹、指纹、人脸、虹膜等代表的生物识别技术相继涌现，无密码时代渐行渐近。孵化于中科院自动化所的虹星科技，凭借10年远距离虹膜识别应用深耕经验和15年视觉成像处理研发管理和实践基础的传承创新，其研发的远距离虹膜识别技术成功入选《科技日报》“2018年中国十大突破技术”，是国内远距离虹膜人脸融合识别的前沿领跑者。在10月28日深圳举办的第十七届中国国际社会公共安全产品博览会（以下简称“2019深圳安博会”）上，中国新闻网记者特别采访了虹星科技创始人兼总经理侯广琦博士，邀请他分享虹膜人脸融合识别技术发展情况、技术应用趋势以及对落地应用和发展的相关看法。",
        content: [
            {
                type: "text",
                inner:
                    "身份识别技术一直是人类长期研究的重要课题。伴随着人工智能技术的发展，掌纹、指纹、人脸、虹膜等代表的生物识别技术相继涌现，无密码时代渐行渐近。孵化于中科院自动化所的虹星科技，凭借10年远距离虹膜识别应用深耕经验和15年视觉成像处理研发管理和实践基础的传承创新，其研发的远距离虹膜识别技术成功入选《科技日报》“2018年中国十大突破技术”，是国内远距离虹膜人脸融合识别的前沿领跑者。在10月28日深圳举办的第十七届中国国际社会公共安全产品博览会（以下简称“2019深圳安博会”）上，中国新闻网记者特别采访了虹星科技创始人兼总经理侯广琦博士，邀请他分享虹膜人脸融合识别技术发展情况、技术应用趋势以及对落地应用和发展的相关看法。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20191031/1.jpg"),
                desc: "虹星科技2019深圳安博会展台",
            },
            {
                type: "title",
                inner: "打造产品矩阵，提供虹膜人脸融合识别整体解决方案",
            },
            {
                type: "text",
                inner:
                    "虹星科技创始人、总经理侯广琦博士毫不掩饰对自家产品的自豪，向记者介绍道，虹星此次带着四大亮点参展，而S300-UC的成熟化正是亮点之一，为改善S300-UC设备的集成便捷性和使用体验，虹星配合了更多的新型架构的器件，将内置模组缩小了50%，将虹膜人脸识别的小型化做到了极致。",
            },
            {
                type: "text",
                inner:
                    "据悉，虹星科技推出的S300-UC与另一款名为W200的手持式虹膜人脸信息采集设备，均于2019年4月入选了相关部门《虹膜数据采集终端合格产品及制造商名录》，借助这两款虹膜注册设备可打通全产品，在展台中任一设备上都可实现联动，真正实现了产品的设备互联，以适应不同细分市场的不同要求。",
            },
            {
                type: "text",
                inner:
                    "谈及虹膜人脸识别的优势，侯广琦博士表示，精准活体检测是虹膜人脸融合识别领先于其他生物识别技术的优势之一，可以避免目前人脸识别易被3D打印照片甚至平面照片破解的尴尬。虹星科技产品利用近红外光与可见光的辅助，捕获人脸三维深度信息，有效进行活体检测、美瞳检测等假体识别，同时还可以识别出基本的年龄、性别与种族的区分。此外，虹星还为活体检测设置了深度传感器，建立一个完整的反欺骗干扰系统部署，能在复杂环境下拥有极佳的假体识别表现。",
            },
            {
                type: "text",
                inner:
                    "为更一步增强虹膜人脸识别的数据安全与管理，虹星科技推出了专属的生物多属性分析云服务。这款被命名为虹星云的云端数据服务，可以为机器人、金融、互联网、零售、教育、房地产等行业提供大规模视觉数据采集、分析和管理的云端存储和服务，并通过领先的数据加密技术确保信息的安全。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20191031/2.jpg"),
                desc: "虹星科技创始人、总经理侯广琦博士接受记者采访",
            },
            {
                type: "title",
                inner: "深度布局全国网络，加快虹膜人脸融合识别普及与应用",
            },
            {
                type: "text",
                inner:
                    "本次安博会上厂商云集，不乏国内外生物识别技术的顶尖厂家，虹星科技也受邀参加安博会的行业论坛，与更多优秀企业一道交流行业信息，共同推动生物识别技术的发展。同时，虹星科技也希望借此了解更多安防行业信息，为企业的研发生产规划提供更多市场需求参照。",
            },

            {
                type: "text",
                inner:
                    "谈及企业的竞争优势，侯广琦博士表示，虹星核心技术团队从事远距离虹膜识别研究领域已有十多年的历史了，有着丰富的技术研究和项目合作经验，作为中科院孵化出来的国家队，在技术方面拥有极强的技术壁垒。众所周知，人脸识别是当下非常热门的生物识别技术，竞争激烈，虹膜识别则有别于人脸识别，虽然安全性能更高，但由于高成本、采集难、技术高的特性，相对市场容量和应用比较有限。虹星科技则突破了传统虹膜的小市场和大热人脸的直面竞争，融合了虹膜和人脸识别，各取所长打开单一识别方式的突破口，占据两个市场的利好，挖掘出了新需求。",
            },

            {
                type: "text",
                inner:
                    "侯广琦博士告诉记者，自从 W200和S300-UC过检前后，虹星便开始在全国布局供应销售网络，建立自己的营销渠道，本次参展虹星科技也希望广泛接触更多志同道合的供销商，寻觅合适的合作伙伴和合作商。",
            },

            {
                type: "text",
                inner:
                    "据悉，虹星科技已全面覆盖光学、电子、数据、AI、处理与虹星云六大版块的尖端技术，未来将立足司法、企业安全支付以及交通领域展开布局。侯广琦表示，伴随着5G和AI技术的不断成熟，安防行业面临突破性革新，迎来全新的智能安防时代，虹膜人脸融合识别技术也注定将在安防行业发挥巨大作用，为更多行业带来更大应用价值与实战意义。",
            },
        ],
    },
    {
        imgPo: "imgLeft",
        en: false, // 是否有英文翻译
        img: require("@/assets/img/news/20191026/1.jpg"),
        title: "三大亮点领跑智慧安防 虹星科技携新品亮剑2019深圳安博会",
        time: "2019.10.26",
        desc:
            '2019年10月28日，第17届中国国际社会公共安全产品博览会(简称"CPSE安博会")将在深圳会展中心盛大开幕。作为全球最权威、最具影响力的智能安防展览会之一，本届CPSE安博会以智慧安防、智慧城市、人工智能、大数据为大方向，将为行业带来一场安防科技盛宴。据悉，有逾1500家来自150个国家和地区的安防企业参展，预计到场客商数量或达65000人，是当前全球规模最大、最权威、最具影响力的安防展会。',
        content: [
            {
                type: "text",
                inner:
                    '2019年10月28日，第17届中国国际社会公共安全产品博览会(简称"CPSE安博会")将在深圳会展中心盛大开幕。作为全球最权威、最具影响力的智能安防展览会之一，本届CPSE安博会以智慧安防、智慧城市、人工智能、大数据为大方向，将为行业带来一场安防科技盛宴。据悉，有逾1500家来自150个国家和地区的安防企业参展，预计到场客商数量或达65000人，是当前全球规模最大、最权威、最具影响力的安防展会。',
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20191026/1.jpg"),
                desc: "深圳会展中心",
            },
            {
                type: "text",
                inner:
                    "旗舰产品亮相6号国际馆6C04展位。自2018年起，虹星科技逐渐将产品理念从最初的“极致单品”升级为“产品矩阵”,综合多款产品组成整体解决方案，进入不同细分市场。如今，出征2019深圳安博会的虹星科技集结了旗下的中远距离虹膜人脸融合识别家族重装上阵，W200手持式虹膜人脸信息采集设备、S300-UC桌面式虹膜人脸信息采集设备、S200P混合生物特征识别一体机、S260P驾驶员身份识别一体机、S200G混合生物特征识别智能闸机、S300-KQ虹膜人脸识别一体化模组等明星产品均悉数亮相，并提前预告了三大亮点，意向世界展示革命性中远距离虹膜融合识别技术的风采。",
            },
            {
                type: "title",
                inner: "亮点一：视觉模组大幅优化 挑战小型化极限",
            },
            {
                type: "text",
                inner:
                    "此次深圳安博会中虹星展台的C位里，S300-UC桌面式虹膜人脸信息采集设备位列其中，这款适用于45~65cm虹膜人脸识别，能够快速准确获取用户的双眼虹膜和彩色人脸图像的设备，在一年来的精心打磨和改良中成熟度获得了显著提升。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20191026/2.jpg"),
                desc: "使用虹星S300-UC桌面式虹膜人脸信息采集设备",
            },
            {
                type: "text",
                inner:
                    "长期以来，中远距离虹膜识别设备的小型化一直是阻碍其发展的极大困扰，如何在保障识别距离、精度与速度的同时，尽可能压缩模组的体积，成为国内外虹膜识别厂商较量研发实力的一大战场。虹星科技此次为改善S300-UC设备的集成便捷性和使用体验，配合更多的新型架构的器件，将内置模组缩小了50%，将虹膜人脸识别的小型化做到了极致。",
            },
            {
                type: "text",
                inner:
                    "模组的小尺寸具备两个非常明显的优势：一是可以内置于极小的智能终端产品里，适用于智能停车、智能楼宇、智慧金融等更宽泛的应用；二是极大节省了硬件成本，提升了产品性价比，更好应用于全行业。可以说，虹星在小型化模组上取得的新进展不仅带来了更加丰富的应用场景，更适合海量联接与广泛部署，更进一步丰富了虹星产品的市场应用。",
            },
            {
                type: "title",
                inner: "亮点二：首创式双重活体检测 多维拒绝假体欺骗",
            },
            {
                type: "text",
                inner:
                    "尽管近年来人脸活体检测有了显著的进步，但人脸识别系统的安全性仍然容易受到打印照片或重放视频等假体攻击。前不久丰巢上线的人脸识别取件功能，就被上海一群小学生用一张打印照片破解了，引起了该功能的紧急下架。虹膜识别鉴于虹膜本身难伪造、易检测的特点，使其在活体检测上拥有了不小的优势。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20191026/3.jpg"),
                desc: "虹星科技产品目前已支持虹膜+人脸的双重活体检测",
            },
            {
                type: "text",
                inner:
                    "作为远距离虹膜+人脸混合识别的领跑者，虹星科技掌握了国际领先的活体检测技术，更首创虹膜+人脸的双重活体检测，在假体攻击数据集测试中取得了显著的性能提升。在活体检测技术上，虹星科技利用近红外光与可见光的辅助，获取多光谱信息，并组建多摄像头矩阵，探索三维深度信息。虹星科技采用的多摄+TOF镜头，可更精准、更深度进行高效活体检测，捕获人脸三维深度信息，并实时同步记录。此外，虹星还为活体检测设置了深度传感器，建立一个完整的反欺骗干扰系统部署，能在复杂环境下拥有极佳的假体识别表现。",
            },
            {
                type: "title",
                inner: "亮点三：引入RISC-V架构 坚持国产化和全自主知识产权",
            },
            {
                type: "text",
                inner:
                    "随着全球RISC-V开源指令集架构的强势崛起，中国厂商更成为了RISC-V指令集阵营的中坚力量。一直坚持民族创新，走全自主研发路线的虹星科技，也将 RISC-V 用于了内部开发芯片，在实现了芯片国产化的战略意义基础上，也为更好服务客户的快速集成与定制化需求提供了极大的空间。与此同时，虹星也搭建了SOC最小系统，便于软件编程与软硬件联合开发，极大提升了灵活度，并在产品功能拓展性、性能提升能力上获得了有力的技术支持。",
            },
            {
                type: "text",
                inner:
                    "几个月前，虹星科技的W200及S300-UC两款虹膜人脸信息采集设备入选相关部门《虹膜数据采集终端合格产品及制造商名录》，完全符合相关文件中虹膜采集设备技术的各项指标要求，成功过检并入选第一批合格产品。虹星科技此次也将在安博会上展示这两款设备强大的虹膜人脸信息注册建库功能，对虹膜统一采集图像与大规模建库管理感兴趣的观众更可以亲赴现场一探究竟。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20191026/4.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "在CPSE安博会期间，虹星还受邀参与了深圳市智慧城市产业协会主办的第十一届SSCIA智慧城市高峰会暨第四届生物特征识别技术创新应用论坛，畅谈远距离虹膜人脸融合识别创造的智慧城市安防新机遇。",
            },

            {
                type: "text",
                inner:
                    "虹星科技此次参展2019深圳安博会，将进一步展示其在计算机视觉领域的雄厚实力，彰显进军安防产业的长远布局与坚定信心，也欢迎大家在10月28至31日，莅临深圳会展中心6号国际馆虹星科技展位6C04，前来参观交流，体验智慧魅力，共话行业未来。",
            },
        ],
    },
    {
        imgPo: "imgLeft",
        en: false, // 是否有英文翻译
        img: require("@/assets/img/news/20190814/1.jpg"),
        title: "山东省潍坊市奎文区区委书记刘泮英莅临虹星科技调研指导工作",
        time: "2019.08.14",
        desc:
            "8月9日下午，山东省潍坊市奎文区委书记刘泮英带队，奎文区投资合作促进局局长武际恩、潍坊创新投资集团有限公司董事长李爱杰一行莅临虹星科技北京公司实地调研考察，虹星科技总经理侯广琦博士、智能制造产品总监刘朝朋全程陪同。",
        content: [
            {
                type: "img",
                inner: require("@/assets/img/news/20190814/1.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "8月9日下午，山东省潍坊市奎文区委书记刘泮英带队，奎文区投资合作促进局局长武际恩、潍坊创新投资集团有限公司董事长李爱杰一行莅临虹星科技北京公司实地调研考察，虹星科技总经理侯广琦博士、智能制造产品总监刘朝朋全程陪同。",
            },
            {
                type: "text",
                inner:
                    "考察组一行参观了虹星科技北京展厅，详细了解了公司发展历程、技术亮点、产品研发及推广应用等有关情况，亲身体验了虹星科技自主研发的W200手持式虹膜人脸信息采集设备、S320壁挂式混合生物特征识别一体机、S260P驾驶员身份识别一体机等旗舰产品,并在公司会议室与虹星科技主要负责人及骨干人员进行了深入交流。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20190814/2.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "会谈中，虹星科技主要负责人及骨干人员介绍了公司在生物特征识别和工业视觉领域的研究成果，并对基于深度学习图像分析技术、图像ISP、关键点定位、三维重建、活体检测等进行了重点推介。考察组一行高度认同虹星科技业内领先的自主核心技术，邀请公司赴潍坊市奎文区进行考察洽谈，热切希望在政府、银行等领域达成深度合作，并表示将为企业发展提供最优环境，助推企业实现高质量发展。",
            },

            {
                type: "text",
                inner:
                    "侯广琦博士代表虹星科技表示将努力践行创新驱动发展战略，全力抓好技术产品创新，不断做精、做强、做大品牌，努力打破国际巨头垄断，争做引领生物特征识别行业创新的国产企业代表，并决定近期赴潍对接洽谈。",
            },

            {
                type: "img",
                inner: require("@/assets/img/news/20190814/3.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "身为中远距离虹膜人脸融合识别开创者与领导者，虹星科技倚靠中科院自动化所过硬的研发背景，以及自身过硬的技术开发能力在国内吸睛无数，不但获得《中国科学报》头版头条刊载及《中国经济时报》的专版报道，更荣膺《科技日报》评选的“2018年中国十大突破技术”，多次实现虹膜识别在技术研发和产业应用端的重大创新。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20190814/4.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "近日，相关部门《虹膜数据采集终端合格产品及制造商名录》正式出炉，虹星科技送检的W200及S300-UC两款虹膜人脸信息采集设备，成功过检并入选合格产品。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20190814/5.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "未来国内虹膜数据库建成后，虹星科技虹膜人脸融合识别产品将在隐蔽式识别、大型活动会议、社会单位身份识别、互联网+可信身份认证等领域大显身手，通过领先的技术和产品为更多国民带来非凡的身份识别体验。",
            },
        ],
    },
    {
        imgPo: "imgLeft",
        en: false, // 是否有英文翻译
        img: require("@/assets/img/news/20190812/1.jpg"),
        title: "虹星科技(北京)入驻仪式圆满举行 产业升级迎虹膜应用拐点",
        time: "2019.08.12",
        desc:
            "8月12日，北京中科虹星科技有限公司举办入驻清华科技园的搬迁仪式，并邀请中国科学院自动化所研究员孙哲南、清华大学教授刘烨斌等来宾召开虹星2019计算机视觉技术交流大会，探讨人工智能时代生物特征识别与工业视觉技术的发展趋势与未来前景。",
        content: [
            {
                type: "text",
                inner:
                    "8月12日，北京中科虹星科技有限公司举办入驻清华科技园的搬迁仪式，并邀请中国科学院自动化所研究员孙哲南、清华大学教授刘烨斌等来宾召开虹星2019计算机视觉技术交流大会，探讨人工智能时代生物特征识别与工业视觉技术的发展趋势与未来前景。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20190812/1.jpg"),
                desc: "侯广琦博士与侯鸿川研究员为入驻仪式揭牌",
            },
            {
                type: "text",
                inner:
                    "仪式中，虹星科技创始人、总经理侯广琦博士首先致欢迎词，向各位来宾表示了热烈的欢迎和诚挚的感谢。他表示：公司的办公场所作为企业发展的窗口和镜子，也见证了虹星科技发展的创业历程，从最早蜷居在中科院自动化所里的几寸小天地 ，历经数次搬迁，一步一个台阶，到今日的清华科技园，办公条件和内外环境有了显著的改善，为周遭清北等名校学子了解并加入虹星提供了崭新的窗口，为虹星寻求更多科创企业合作提供了更多的可能，塑造了虹星科技新的企业对外形象，更预示了虹星“一颗红星向未来”的美好发展前景。",
            },
            {
                type: "text",
                inner:
                    "随后，中国科学院自动化所孙哲南研究员也进行了致辞发言，谈到谭铁牛院士是如何在90年代带领中科院自动化所自主研发虹膜技术发展，而虹星科技作为中科院中远距离虹膜技术的产业化代表，迎来了虹膜应用前所未有的前景与机遇，在公共安防、金融支付、人居安全等领域都大有可为，并希望虹星科技能推动虹膜识别技术成为下一个改变社会生活的重要科技拐点。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20190812/2.jpg"),
                desc: "侯广琦博士带领来宾参观虹星科技北京展厅",
            },
            {
                type: "text",
                inner:
                    "上午10时30分，虹星科技（北京）入驻仪式正式开启揭牌环节，现场气氛热烈喜庆，来宾们纷纷表示祝贺。虹星科技（北京）此次落户的清华科技园，地处北京中关村科技园区的核心地带，这里聚集了数量众多的著名高等院校和研究院所，是中国最大、世界少有的智力密集区，同时享有中关村科技园区大规模基础设施建设和一系列配套优惠政策，也为虹星科技加快科研成果向生产力的转化、高新技术研发、创新人才培育等环节提供更大的发展空间与可能。",
            },
            {
                type: "text",
                inner:
                    "虹星科技是中国科学院自动化研究所在人工智能领域孵育的一家高科技企业，拥有国内最大远距离虹膜融合识别研发团队，也是中国将虹膜融合识别投入商业应用的创新型高新技术公司，核心技术团队来源为中科院自动化研究所的模式识别国家重点实验室，拥有10年远距离虹膜识别应用深耕经验，15年视觉成像处理研发管理和实践基础，旗下拥有虹膜人脸采集注册、中远距离虹膜人脸融合等一系列多模态生物特征识别产品及工业视觉产品。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20190812/3.jpg"),
                desc: "虹星科技研发团队与专家们探讨交流计算机视觉技术",
            },
            {
                type: "text",
                inner:
                    "虹星科技在天津、北京、深圳等地均设立了办公点，组建了国内最大规模的远距离虹膜识别研究团队，吸纳了来自中科院、清华、北理工、电子科大等各大知名高校以及英伟达、小米、海尔、清华同方、京东方等大型企业的骨干优秀人才，坐拥包括图像ISP、物体检测、人脸检测、关键点定位、深度估计、三维重建、虹膜识别、活体检测等领域40多项核心发明专利和软件著作权。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20190812/4.jpg"),
                desc: "虹星科技旗下的中远距离虹膜人脸融合识别产品",
            },
            {
                type: "text",
                inner:
                    "虹星科技率先推出国内商业化远距离虹膜融合识别产品及解决方案，采用人脸融合+活体检测技术，识别全程控制在2秒内，以千万分之一误识率对亿级规模人群进行高效稳定安全识别，目前已与机器人、金融、互联网、零售、教育、房地产等行业建立合作关系，并在天津港口、新疆平安社区管理等落地项目中投入使用，目前虹星科技旗下拥有W200手持式虹膜人脸信息采集设备、S200G/S320G系列“虹膜识别+活体检测+人证比对”三合一智能闸机、S200混合生物特征识别一体机、S200P混合生物特征识别一体机、S320壁挂式混合生物特征识别一体机、S200M系列虹膜识别模组、M100系列虹膜识别模组、U100桌面式虹膜人脸识别设备、S300-KQ虹膜人脸识别一体化模组、S300-UC中距离注册识别模块、S260P驾驶员身份识别一体机等一系列多模态生物特征识别产品。",
            },
            {
                type: "text",
                inner:
                    "身为中远距离虹膜人脸融合识别开创者与领导者，虹星科技倚靠中科院自动化所过硬的研发背景，以及自身过硬的技术开发能力在国内吸睛无数，不但获得《中国科学报》头版头条刊载及《中国经济时报》的专版报道，更荣膺《科技日报》评选的“2018年中国十大突破技术”，多次实现虹膜识别在技术研发和产业应用端的重大创新。",
            },
            {
                type: "text",
                inner:
                    "近日，相关部门《虹膜数据采集终端合格产品及制造商名录》正式出炉，虹星科技送检的W200及S300-UC两款虹膜人脸信息采集设备，完全符合《用于刑事侦查业务的虹膜采集设备技术要求》（用于千万级刑专子系统虹膜库建设）的各项指标要求，成功过检并入选合格产品。",
            },
        ],
    },
    {
        imgPo: "imgLeft",
        en: false, // 是否有英文翻译
        img: require("@/assets/img/news/20190701/1.jpg"),
        title: "@你，你有一封未查收的全球虹膜识别出行指南！",
        time: "2019.07.01",
        desc:
            "六月是个不轻松的月份，接踵而至的高考、中考、期末考逼急了学生和家长，骤升的气温也挑战着上班族早晚高峰时段的汗腺，出国旅行成了不少人解救焦虑的一针强心剂。七月乍到，有的人已经仗剑执马奔远方了。",
        content: [
            {
                type: "text",
                inner:
                    "六月是个不轻松的月份，接踵而至的高考、中考、期末考逼急了学生和家长，骤升的气温也挑战着上班族早晚高峰时段的汗腺，出国旅行成了不少人解救焦虑的一针强心剂。七月乍到，有的人已经仗剑执马奔远方了。",
            },
            {
                type: "text",
                inner:
                    "无论你是否计划了一场说走就走的旅行，虹星都为你贴心订制了一次尽赏全球虹膜识别风光的世界之旅，邀你在我国完成13亿虹膜采集建库的浩瀚工程前，提前感受一波虹膜识别落地民生后能享受的切实红利。",
            },
            {
                type: "title",
                inner: "东亚",
            },
            {
                type: "text",
                inner:
                    "首先不妨把目光移向咱们的东亚邻居，如果你的出游目的地是韩国，那么你极有可能会降落在韩国最大的机场——仁川机场。作为国际旅客吞吐量全球第7、亚洲第4的国际性机场，仁川机场从2018年10月起就已安装虹膜识别安全系统，在机场内的速通门安装虹膜识别系统，针对自愿提供虹膜信息的员工进行试运营。据韩国仁川国际机场公社透露，最快在2020年，从韩国出发的乘客们就有望实现无需拿护照排队，就能凭借扫描虹膜领取纸质登机了。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20190701/1.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "在东亚国家中能与韩国不相伯仲，跻身国人旅行热门选择的便是日本了。针对虹膜识别，日本科学研讨也早已将其与指纹识别、人脸识别、声音识别等其他生物特征识别作出过合理的数据推理比较，肯定了虹膜识别超高的准确率。在日本的narita机场，到达机场后办理好一切手续的登机乘客，只需在虹膜采集摄像机前扫描一下眼睛，即可在检票口取票登机。日本通讯公司NTT Docomo更是早在2015年就推出了全球首款使用虹膜识别的智能手机。拿着这款超先进智能手机，只需对着手机摄像头来几下“深情款款”的眼神交流，用户就可以解锁手机，开启手机购物之旅。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20190701/2.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner: "",
            },
            {
                type: "title",
                inner: "北美",
            },
            {
                type: "text",
                inner:
                    "受到中美贸易战的影响，国人近期对赴美旅游的热情大大降低，但这不妨碍我们“师夷长技以制夷”，增进对美国利用虹膜识别技术的了解，百利而无一害。2017年，美国生物扫描公司Clear在纽约肯尼迪机场、亚特兰大机场等美国22个机场推出了一款用虹膜+指纹进行PreCheck（登机检查）的服务，宣称可以让用户快速且无缝隙通过机场安检。Precheck允许人们穿着鞋、大衣、系着腰带、带着电脑进行安检，搭乘Clear的服务，只需眼睛一扫、手指一按，旅客几乎可以“飞速”到达登机口，省去了检查登机牌和护照的冗长流程，美国国土安全局更把Clear定义为“合格的技术”。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20190701/3.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "缺乏可靠的身份识别技术，一直是过去美国政府的一块心病，据美国相关数据显示，每年因居民证件丢失或管理不当，政府有上亿美元的福利款会被冒领；著名的信用卡企业 Master Card 公司每年因信用卡诈骗约损失4.5 亿美元；而美国移动通信每年因用户密码被破解至少损失10亿美元。然而，在华盛顿和阿拉巴马等城市引入基于虹膜识别的身份认证系统后，个人医疗记录的保密性得到了有效保障，只有被授权的用户，才能靠着虹膜识别获得相应记录的访问权限，把冒名顶替者拒之门外。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20190701/4.jpg"),
                desc: "",
            },
            {
                type: "title",
                inner: "欧洲&澳洲",
            },
            {
                type: "text",
                inner:
                    "除了美国之外，像德国、荷兰等欧洲国家同样为了保障公共安全，在部分机场及一些高安全级别机构采用了虹膜识别身份验证系统，对场内工作人员身份进行高可靠性的认证，以保证不同级别区域按权限的访问规则，以防止各种非法入侵。其中，德国更在法兰克福国际机场对虹膜识别的可靠性进行了论证，利用新式虹膜识别系统检验登机乘客的虹膜来辨识身份，试验结论证实了，虹膜识别的可靠性无疑是最好的。",
            },
            {
                type: "text",
                inner:
                    "如果你计划去大不列颠瞧一瞧，那么飞往英国最繁忙的机场航站——希思罗机场１号航站大楼前，你可以事先将本人的一张眼部虹膜照片和护照内容上传到机场的相关数据库内，然后在抵达机场时在一个自动通关亭内进行眼部扫描，这样在通关时使用该系统就可以避开繁琐的护照检查了。同时，英国的非法移民较多，利用基本的身份鉴别方法不是十分可靠，容易让一些不法分子钻空子，所以虹膜技术的远距离采集更凸显出至关重要的作用。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20190701/5.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "德国为防止偷窃婴儿的事件，更在医院婴儿室里采用了虹膜识别装置，此装置识别只允许孩子的父母，医生和护士进入屋内。这也是像在医院这种无菌环境下，唯一能免接触且在非不可视特性下完成身份验证的识别技术。",
            },
            {
                type: "text",
                inner:
                    "澳大利亚布里斯班旅游区由于入室盗窃频发，也将多处公寓住宅钥匙换成了主人的虹膜，一来可以防止小偷行窃，提高人们住宅的安全性，二来也节省了屋主随身携带钥匙的烦恼，甚至还可以直接去当地的健身房，让虹膜成为自己最潮的VIP会员卡。",
            },
            {
                type: "title",
                inner: "中东",
            },
            {
                type: "text",
                inner:
                    "沙漠中的奢华之都——迪拜是近年来国人青睐的新兴旅游景点，但迪拜所在的阿拉伯联合酋长国，却长年来都在跟众多的非法入境者角力。早从2002年10月起，地处西亚的阿联酋就开始记录所有被驱逐人员的虹膜纹理信息，近年来更利用基于虹膜识别的身份认证手段，确认那些被驱逐且企图更换身份回国的人员。据统计，仅不到两年时间，阿联酋就成功拦截了近万名此类人员，卡塔尔更有900万人用上了虹膜证件，可谓收效颇丰。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20190701/6.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "鉴于钥匙可以伪造、密码可以破解，极难仿造的虹膜识别技术更成了保障银行业安全性的黑科技。在油田遍野，富豪层出的阿拉伯地区，对防御那些企图窃取银行客户账号密码来的不法分子更是充满了戒备，这也让虹膜识别设备早早应用在阿拉伯富人区的ATM机上。基于中科院自动化所核心技术的iBank虹膜识别银行解决方案则成功应用于约旦和也门的多家银行，与银行核心业务系统实现集成，为数十万注册用户提供“无卡无密码”的金融服务，无需插卡输入密码，只要拍摄一张虹膜图像，即可轻松取款，避免了插卡信息泄漏和忘记取卡的状况，即使是同卵孪生的双胞胎也无法登入对方的银行账户。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20190701/7.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "放眼多难之国阿富汗，难民救援问题也成了联合国与美国联邦难民署的一项重任。联合国也为此使用虹膜识别系统鉴定难民的身份，防止同一个难民多次领取救济品，保障救援工作的公平性。同样的系统在巴基斯坦与阿富汗的难民营中也得到应用，总共有超过200万的难民使用了虹膜识别系统，这套系统对于联合国对人道主义援助物资的合理分配起到了很关键的作用。",
            },
            {
                type: "text",
                inner:
                    "以上种种，其实都只是虹膜识别应用的冰山一角，随着全球虹膜信息数据库的完善和虹膜识别产品、技术的精进改良，虹膜识别的应用前景还有广阔区域待开发。反观国内，虽然虹膜识别装置的使用还未大规模普及，但我国相关部门已开启了千万级刑专子系统虹膜库的建设工作。虹膜作为公民身份信息的重要生物特征，未来也可能加入我国第三代身份证录入的范畴。有印度的10亿以上的UID虹膜采集案例在先，届时，我国虹膜识别的未来蓝海将不可估量。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20190701/8.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "为辅助建立全国统一的虹膜原始图像数据库，加快面向公共安全应用的产品定制和应用推广，结合公关部门应用需求，及时开展规模化应用，虹星科技也定制开发了两款高端虹膜人脸信息采集装置——S300-UC桌面式与W200手持式虹膜人脸采集设备，支持固定式/便捷式采集，固定场所或现场采集均可灵活使用，具有贴合面部及眼部采集习惯的人体工程学结构设计，体积轻便易用，可实现秒级的注册和识别，采集设备高度集成，可实现护照/身份证、人脸、虹膜等多模态身份信息采集，适合各种复杂环境下大规模人群数据采集，引领亿级面部多模态识别，成为保障公民隐私最坚实的一道防火墙。近日，相关部门《虹膜数据采集终端合格产品及制造商名录》正式出炉，虹星科技送检的W200及S300-UC两款虹膜人脸信息采集设备，完全符合《用于刑事侦查业务的虹膜采集设备技术要求》（用于千万级刑专子系统虹膜库建设）的各项指标要求，成功过检并入选合格产品。",
            },
            {
                type: "text",
                inner:
                    "面对当今环境下中华民族企业面对的新危机，虹星科技作为身为远距离虹膜人脸融合识别开创者与领导者，一直秉持着核心研发团队在中科院自动化所时潜心钻研、埋头技术的优良传统，牢记民族使命，为争做打破国际巨头垄断、坚持民族品牌自主研发、引领生物特征识别行业创新的国产企业代表不懈奋斗，愿虹星科技能推动我国的多模态面部识别独立研发事业真正落地民生，为行业进步、国民福祉和商业文明创造价值。",
            },
        ],
    },
    {
        imgPo: "imgLeft", // 图片的位置，左或者右-16
        en: false, // 是否有英文翻译
        img: require("@/assets/img/news/201808170900/1.jpg"), // 封面图
        title: "CCBR2018完美收官 虹星科技远距离虹膜人脸融合识别技术聚焦业界目光", // 标题
        time: "2018.08.17", // 时间
        desc:
            "8月12日，为期2天的第十三届中国生物特征识别大会(CCBR2018) 圆满收官。CCBR大会作为业内顶级生物特征识别学术交流会议，汇聚了200多名国际一流的生物特征识别领域专家及全球各大高校科研机构学者共聚交流。担任大会主席的中科院自动化所孙哲南研究员，在开幕式上对到场者致以欢迎辞并发表了开题演说。", // 封面描述
        content: [
            {
                type: "img",
                inner: require("@/assets/img/news/201808170900/1.jpg"),
                desc: "第十三届中国生物特征识别大会",
            },
            {
                type: "text",
                inner:
                    "8月12日，为期2天的第十三届中国生物特征识别大会(CCBR2018) 圆满收官。CCBR大会作为业内顶级生物特征识别学术交流会议，汇聚了200多名国际一流的生物特征识别领域专家及全球各大高校科研机构学者共聚交流。担任大会主席的中科院自动化所孙哲南研究员，在开幕式上对到场者致以欢迎辞并发表了开题演说。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201808170900/2.jpg"),
                desc: "CCBR2018主席孙哲南研究员在开幕式致欢迎辞",
            },
            {
                type: "text",
                inner:
                    "本届CCBR邀请了在生物识别领域久负盛名的美国Anil K. Jain教授、美国伦斯勒理工学院Qiang Ji教授、美国微软研究院Gang Hua博士等国际著名学者做特邀报告。虹星科技作为人工智能领域的代表企业受邀亮相，创始人侯广琦博士在大会上发表的远距离虹膜人脸融合识别主题演讲，博得与会者的一致青睐。",
            },
            {
                type: "text",
                inner:
                    "此次CCBR大会上，侯广琦博士的报告主题为“远距离虹膜人脸融合识别：开创亿级人群无证通行新时代”，详尽阐述了远距离虹膜人脸融合识别技术的发展现状，及虹星科技在独立研发该技术上的重要进展。侯广琦表示，远距离虹膜识别克服了多模态融合的种种限制，与人脸识别具有高度的互补性。凭借自身优秀的独立研发团队，虹星科技在检测分割、虹膜人脸融合识别、活体检测、粗分类、大规模虹膜数据生成等多项关键技术上保持国际领先水平，在国内与美国获得40多项核心发明专利和软件著作权。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201808170900/3.jpg"),
                desc: "侯广琦博士发表远距离虹膜人脸融合识别报告",
            },
            {
                type: "text",
                inner:
                    "据侯广琦博士介绍，虹星科技拥有着20年远距离虹膜识别应用深耕经验和15年视觉成像处理研发管理和实践基础，在国内率先推出商业化远距离虹膜融合识别产品及解决方案，采用人脸融合+活体检测技术，识别全程控制在2秒内，以千万分之一误识率对亿级规模人群进行高效稳定安全识别，为开创亿级人群无证通行新时代孕育了坚实的技术支持与成熟的产品支持。",
            },
            {
                type: "text",
                inner:
                    "在侯广琦博士演讲过程中，与会专家不时点头赞许，对虹星科技的虹膜人脸融合技术给予高度肯定。在随后的报告交流环节，面对在场学者们的踊跃发问，侯广琦博士也逐一进行解答，剖析融合技术的成像难点与技术堡垒，结合虹星科技的行业应用解决方案及实际落地场景，阐明该技术的广阔应用前景及未来发展趋势。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201808170900/4.jpg"),
                desc: "Anil K. Jain教授、侯广琦博士领取大会颁发的荣誉证书",
            },
            {
                type: "text",
                inner:
                    "会议召开期间，众多参会代表对虹星科技的虹膜人脸融合产品也表现出了极大的热情，在场外体验区积极体验虹星带来的产品。此次虹星科技展示集虹膜人脸信息注册于一体的W200手持式采集设备，及颜值惊人、内置自动升降镜头的S200P混合生物特征识别一体机，均让使用者感受到多模态生物识别设备在便捷性到肢体感官上带来的崭新体验。",
            },
            {
                type: "text",
                inner:
                    "截至目前，虹星科技的W200、S200系列混合生物特征识别设备已成功投入市场，近日更推出两款新品——S260壁挂式设备与智能人车识别系统，这也是虹星科技在实现“创造无证通行新时代”宏伟蓝图的一次突破，为智能出行发展提供了新的方向。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201808170900/5.jpg"),
                desc: "与会者参观体验虹星科技远距离虹膜人脸融合识别产品",
            },
            {
                type: "text",
                inner:
                    "虹星科技作为新兴科技力量，在不断给自己再生新方式新渠道的同时，也将给行业带来共荣与变革，而这种变革将是巨大的。这不仅是虹星科技的产品使命，也是生物识别行业在新时代下的发展之道。",
            },
        ],
    },
    {
        imgPo: "imgLeft", // 图片的位置，左或者右-18
        en: false, // 是否有英文翻译
        img: require("@/assets/img/news/201808101534/1.jpg"), // 封面图
        title: "CCBR2018中国生物特征识别大会召开 虹星远距离虹膜融合识别技术报告将同步发布", // 标题
        time: "2018.08.10", // 时间
        desc:
            "2018年8月11日至12日，第十三届中国生物特征识别大会（CCBR2018）将隆重举行。作为联合主办方之一的虹星科技，更将在会议期间同步发布远距离虹膜融合识别技术报告。据悉，此次会议汇聚了国际顶尖的生物特征识别领域专家学者，谭铁牛院士也将作为顾问委员会成员之一，坐镇本次大会", // 封面描述
        content: [
            {
                type: "img",
                inner: require("@/assets/img/news/201808101534/1.jpg"),
                desc: "CCBR2018中国生物特征识别大会",
            },
            {
                type: "text",
                inner:
                    "2018年8月11日至12日，第十三届中国生物特征识别大会（CCBR2018）将隆重举行。作为联合主办方之一的虹星科技，更将在会议期间同步发布远距离虹膜融合识别技术报告。据悉，此次会议汇聚了国际顶尖的生物特征识别领域专家学者，谭铁牛院士也将作为顾问委员会成员之一，坐镇本次大会。在国际生物识别届享有极高声誉的泰斗级人物——美国密歇根州立大学的Anil K. Jain教授，更将亲赴大会报告未来生物识别技术的发展趋势。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201808101534/2.jpg"),
                desc: "泰斗级大师Anil K. Jain教授将赴CCBR2018报告",
            },
            {
                type: "text",
                inner:
                    "虹星科技CEO侯广琦博士也应邀出席本次CCBR2018大会，将于11日上午进行以《远距离虹膜人脸融合识别开创亿级人群无证通行新时代》为题的学术报告，全面阐述远距离虹膜人脸融合识别技术的技术难点与应用前景，以及虹星科技自主研发的相关产品在大规模人群出行场景下的解决方案与应用案例。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201808101534/3.jpg"),
                desc: "虹星科技侯广琦将围绕远距离虹膜人脸融合技术发表报告",
            },
            {
                type: "text",
                inner:
                    "同时，虹星科技将携W200虹膜人脸注册设备及S200P混合生物识别一体机旗舰版赴会，向到场的各位与会者展示远距离虹膜人脸融合识别产品在具有鲁棒三维活体检测的高精度身份认证上的强劲实力，实在令人拭目以待。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201808101534/4.jpg"),
                desc: "虹星科技W200与S200P设备也将亮相本次识别大会现场",
            },
            {
                type: "text",
                inner:
                    "中国生物特征识别大会（CHINESE CONFERENCE ON BIOMETRIC RECOGNITION）是由中国人工智能学会（CAAI）主办的国内生物特征识别领域的学术盛会。生物识别是模式识别、图像处理、人工智能等学科领域的前沿方向，其在安全领域发挥着重要作用。自2000年以来，CCBR已经在北京、杭州、西安、广州、济南、沈阳、天津、成都和深圳等地成功举办了12届，有力地促进了国内本领域的学术和技术发展。",
            },
        ],
    },
    {
        imgPo: "imgLeft", // 图片的位置，左或者右-19
        en: false, // 是否有英文翻译
        img: require("@/assets/img/news/201807301600/1.jpg"), // 封面图
        title: "香港特首林郑月娥赴北京参观 为虹星科技旗舰产品驻足点赞", // 标题
        time: "2018.07.30", // 时间
        desc:
            "7月26日，香港特区行政长官林郑月娥访问北京，期间前往中国科学院自动化研究所实地考察，参观了以虹星科技S200P远距离虹膜融合识别设备为代表的国际前沿远距离虹膜识别技术。在听取现场介绍内容后，林郑月娥对其技术及产品予以肯定，并对前沿科技为驱动的创新力量，未来在粤港澳大湾区建设中的作用表示了期待。", // 封面描述
        content: [
            {
                type: "text",
                inner:
                    "7月26日，香港特区行政长官林郑月娥访问北京，期间前往中国科学院自动化研究所实地考察，参观了以虹星科技S200P远距离虹膜融合识别设备为代表的国际前沿远距离虹膜识别技术。在听取现场介绍内容后，林郑月娥对其技术及产品予以肯定，并对前沿科技为驱动的创新力量，未来在粤港澳大湾区建设中的作用表示了期待。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201807301600/1.jpg"),
                desc: "林郑月娥参观以虹星科技S200P产品为代表的国内先进虹膜识别技术",
            },
            {
                type: "text",
                inner:
                    "林郑月娥提到，粤港澳大湾区的规划工作一直在进行中，香港特别行政区政府也参与规划编制工作。大湾区要建造创新科技中心，相信各地可以分工互补、互利共赢。在“一国两制”方针下，希望香港可以发挥独特优势，为粤港澳大湾区发展作出贡献。",
            },
            {
                type: "text",
                inner:
                    "远距离虹膜识别技术作为中科院自动化研究所高精尖的国际领先技术，也是我国自主研发科技的标志性象征之一。由此孕育的虹星科技，更是自动化所将高新技术产业化的模范代表。依托于所内模式识别国家重点实验室的虹星科技，在深挖市场需求的同时，结合长期与相关部门合作的实践优势，专注致力于远距离虹膜识别应用的成果转化，推出成熟的多模态生物特征识别系列产品，实现了国内市场上远距离虹膜融合识别产品从无到有的重大突破。",
            },
            {
                type: "text",
                inner:
                    "虹星科技创新式的虹膜+人脸识别技术，长达1.2m的工作距离远超传统虹膜识别的0.4m限制，将身份验证全程缩短至2s内，并根据客户对功能及场景的不同需求，开发出W200手持式虹膜人脸信息注册采集设备、S200标准版混合生物特征识别一体机、S200G “人证+活体+虹膜”防暴防冲撞智能闸机等主打产品，是为适用于亿万级人群的高精度身份认证提供大规模视觉数据采集、分析和管理的硬件—软件—算法整体解决方案。",
            },
            {
                type: "text",
                inner:
                    "未来，虹星科技将在智慧安防、智能出行、智慧金融与智能教育等领域继续探索落实，希望借助自身全球领先的科技创新与技术应用，全力参与到粤港澳大湾区以及国内其他智慧城市建设当中，为粤港澳大湾区打造成国际创新科技中心助力。",
            },
        ],
    },
    {
        imgPo: "imgLeft", // 图片的位置，左或者右-15
        en: false, // 是否有英文翻译
        img: require("@/assets/img/news/201812280738/1.jpg"), // 封面图
        title: "2018年国内十大技术突破：虹星远距离虹膜识别、22纳米光刻机、大型航天器回收", // 标题
        time: "2018.12.28", // 时间
        desc:
            "《科技日报》记者 唐芳 2018年，高新技术成果在各行各业开花结果，在提高产业效能的同时也为人们的生活创造了更多便利。科技创新主体不约而同向着“自主掌握核心技术，打破国外垄断”的目标前行。", // 封面描述
        content: [
            {
                type: "title",
                inner: "《科技日报》记者 唐芳",
            },
            {
                type: "text",
                inner:
                    "2018年，高新技术成果在各行各业开花结果，在提高产业效能的同时也为人们的生活创造了更多便利。科技创新主体不约而同向着“自主掌握核心技术，打破国外垄断”的目标前行。 盘点这一年的核心技术：22纳米光刻机、450公斤人造蓝宝石、0.12毫米玻璃、大型航天器回收、盾构机“弃壳返回”、远距离虹膜识别……哪一个不夺人眼球！ ",
            },
            {
                type: "title",
                inner: "虹膜识别 1.2米远两秒搞定",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201812280738/1.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "虹膜识别是除DNA以外最可靠的生物识别技术，唯一、防伪。最开始虹膜识别要像用望远镜一样把眼睛贴在设备上，后来扩大到设备半米内识别。11月份，虹星科技正式投产“驾驶员生物特征识别一体机”，将虹膜识别距离拓展到1.2米，扫一眼即可，无需过多配合。 ",
            },
            {
                type: "text",
                inner:
                    "每个人的虹膜都独一无二。红外光条件下，可呈现丰富纹理特性，稳定特征点200多个，刷眼后仪器提取出具备高区分力的特征码，与数据库进行比对，这一过程称为虹膜识别。虹膜识别的优势主要体现在庞大数据库中精准找人。在监控视频中准确找一个人，1万的人群基数用人脸识别，10万人以下用指纹识别，100万个人应当用虹膜识别。 ",
            },
            {
                type: "text",
                inner:
                    "虹膜仅约1平方厘米，人脸是300平方厘米，识别难度相差300倍。距离稍远，难以采集到清晰的虹膜纹理；而且人本身的晃动和眨眼，会让成像存在运动模糊、眼皮遮挡等一系列问题。",
            },
            {
                type: "text",
                inner:
                    "虹星科技成像阶段使用千万像素以上的图像传感器，保证足够的虹膜分辨率；精心计算近红外光源的角度和强度，在不伤害人眼的前提下照亮虹膜纹理；将智能算法移到成像设备内，使成像与计算协同作业；快速图像质量判断算法，丢弃低质量图像，专注识别高质量虹膜图像；优化算法，一秒处理上百张千万像素的虹膜图像。最终做到了1.2米距离内2秒虹膜识别。",
            },
        ],
    },
    {
        imgPo: "imgLeft", // 图片的位置，左或者右-14
        en: false, // 是否有英文翻译
        img: require("@/assets/img/news/201901240900/1.jpg"), // 封面图
        title: "虹星科技亮相第二届生物特征识别青年论坛 探讨人工智能时代生物识别新趋势", // 标题
        time: "2019.01.24", // 时间
        desc:
            "1月21日，第二届生物特征识别青年论坛在中科院自动化所报告厅成功举办，本次论坛是由中国图像图形学学会主办，CSIG视觉大数据专委会和CSIG机器视觉专委会、生物识别产业技术创新战略联盟承办。200多名来自中科院、清华大学、北京大学、微软、华为、阿里、百度、京东、滴滴、虹星科技、商汤等单位的生物识别产学研精英汇聚一堂，分享内容涵盖了变形指纹识别、人脸识别与数据技术、新零售场景下的生物识别等主题.....", // 封面描述
        content: [
            {
                type: "img",
                inner: require("@/assets/img/news/201901240900/1.jpg"),
                desc: "第二届生物特征识别青年论坛成功召开",
            },
            {
                type: "text",
                inner:
                    "1月21日，第二届生物特征识别青年论坛在中科院自动化所报告厅成功举办，本次论坛是由中国图像图形学学会主办，CSIG视觉大数据专委会和CSIG机器视觉专委会、生物识别产业技术创新战略联盟承办。200多名来自中科院、清华大学、北京大学、微软、华为、阿里、百度、京东、滴滴、虹星科技、商汤等单位的生物识别产学研精英汇聚一堂，分享内容涵盖了变形指纹识别、人脸识别与数据技术、新零售场景下的生物识别等主题。作为虹膜人脸融合识别技术的领军企业，虹星科技侯广琦博士也发表了题为“远距离虹膜识别”的报告，探讨了人工智能时代生物特征识别技术的新突破、新应用和新趋势。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201901240900/2.jpg"),
                desc: "孙哲南研究员开场致辞",
            },
            {
                type: "text",
                inner:
                    "当日上午9点整，中国科学院自动化研究所副总工程师、虹星科技首席技术顾问孙哲南研究员出席会议，并致开场词。他提到，生物特征识别已得到“政产学研用”多方高度关注，已经成为“互联网+”行动计划和“新一代人工智能规划”等国家战略的重要方向、阿里达摩院预言2019年十大科技趋势之一、人工智能落地最快和商业市场规模最大的主要方向之一、模式识别和计算机视觉的学科前沿方向，并且涉及公众利益攸关隐私、道德、法律等问题，因此需要大家加强沟通研讨和团结协作，共同提高我国生物特征识别的技术和应用水平。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201901240900/3.jpg"),
                desc: "虹星科技CEO侯广琦博士作报告",
            },
            {
                type: "text",
                inner:
                    "虹星科技CEO侯广琦博士在题为“远距离虹膜识别”的报告中表示，生物特征识别已在人们生活过程中深度应用，并带来极强的便利性，虹膜生物特征的特点以及其积淀已久的研究发展历程，如今已遇上了蓬勃发展中的互联网和人工智能对无处不在的身份认证的应用需求与新挑战。侯博士还着重分析了虹膜识别研究过程中面临的难题和技术发展趋势，介绍了虹星科技在远距离虹膜识别研发，包括成像和算法等技术以及产品化取得的最新进展，特别是展示了行进中虹膜识别技术，获得行业内外的高度认可和关注。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201901240900/4.jpg"),
                desc: "虹星科技已研发适合不同场景需求的一系列产品",
            },
            {
                type: "text",
                inner:
                    "作为中科院自动化所在人工智能领域孵化的硬科技企业，虹星科技目前已研发S260P驾驶员身份识别设备、S320壁挂式混合生物特征识别一体机、W200手持式虹膜人脸信息采集设备、M100 系列虹膜识别模组、U100 桌面式虹膜人脸识别设备、S200P混合生物特征识别一体机、S200G混合生物识别智能闸机、W200手持式虹膜人脸信息采集设备等系列产品，结合后台信息管理系统，可覆盖并满足大部分行业及不同应用场景下对高效安全身份验证的需求。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201901240900/5.jpg"),
                desc: "虹星科技概念海报",
            },
            {
                type: "text",
                inner:
                    "虹星科技近日攻克并实现应用的行进中虹膜识别技术，更是对于整个生物特征识别行业的一次技术创新改造，填补了国内在该领域的空白，同时有望颠覆整个产业的发展认知。",
            },
            {
                type: "text",
                inner:
                    "“希望到2020年，我们能够找到为用户在精准识别基础上提供新的用户体验。”侯广琦博士说，虹星科技核心技术既然做生物特征识别，未来就要朝着服务“人”这个方向努力，“任何科技的发展都是为了服务人，服务是虹星科技未来发展的大方向。”",
            },
        ],
    },
    {
        imgPo: "imgLeft", // 图片的位置，左或者右-13
        en: false, // 是否有英文翻译
        img: require("@/assets/img/news/201905070900/1.jpg"), // 封面图
        title: "天津市科技局局长戴永康莅临虹星科技调研指导", // 标题
        time: "2019.05.07", // 时间
        desc:
            "5月5日下午，天津市科技局局长戴永康率队，天津市科技局副局长祖延辉、滨海新区科技局局长陈良文、开发区管委会副主任于梅、开发区科技局副局长徐代鸿一行莅临虹星科技考察调研，了解企业发展情况", // 封面描述
        content: [
            {
                type: "img",
                inner: require("@/assets/img/news/201905070900/1.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "5月5日下午，天津市科技局局长戴永康率队，天津市科技局副局长祖延辉、滨海新区科技局局长陈良文、开发区管委会副主任于梅、开发区科技局副局长徐代鸿一行莅临虹星科技考察调研，了解企业发展情况",
            },
            {
                type: "text",
                inner:
                    "在虹星科技创始人侯广琦博士的陪同下，戴永康局长一行参观了公司展厅，观看了虹星科技最新的产品展示及演示，充分了解了虹星科技成立一年多来的发展历程。戴永康局长认真听取了侯博士的介绍，并且详细的询问了虹星的产品开发情况、市场开拓进展、应用场景、发明专利及融资情况，得到了侯博士的一一解答。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201905070900/2.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "天津市领导、新区领导及开发区领导对于虹星科技的两款产品——S300-UC（USB桌面式虹膜人脸信息采集设备）及W200（手持式虹膜人脸信息采集设备）已经通过相关部门产品测试一事也特别关心，并进行了热烈的讨论。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201905070900/3.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "在考察过程中，永康局长对于虹星科技在科技创新方面取得的成果给予充分肯定，关心虹星科技上下游产业链情况，表示将会积极帮助虹星科技对接产业链上的优质企业，极大的鼓舞了虹星科技全体员工的士气。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201905070900/4.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "虹星科技作为无证精准身份识别领跑者，是中国科学院自动化研究所在人工智能领域孵育的一家高科技企业，拥有国内最大的远距离虹膜融合识别研发团队，长年专注于计算机视觉与模式识别研究领域。虹星科技以智能三维人机交互和远距离虹膜识别两大核心技术，打造出全球具有“虹膜识别+活体检测+人证比对”功能的产品，成为国内将虹膜融合识别投入商业应用的创新型企业。虹星科技成立一年多以来，得到了天津市、新区和开发区各级领导的重视，积极为虹星科技产品落地协调应用场景。成立当年，虹星科技即研发出十余款新产品，2019年将成为虹星科技天津市场爆发的元年。",
            },
            {
                type: "text",
                inner:
                    "虹星科技在技术精益求精的同时，也在多个行业应用细分场景下探索尝试，目前已与金融，房地产等行业近百家领军企业建立合作，为其提供精准智能识别及大规模视觉数据采集、大规模人群身份信息管理等完整解决方案，希望也能为天津扫黑除恶行动添砖加瓦，为未来构建智慧城市、平安城市提供最精准、最安心的保障。",
            },
        ],
    },
    {
        imgPo: "imgLeft", // 图片的位置，左或者右-12
        en: false, // 是否有英文翻译
        img: require("@/assets/img/news/201905150900/1.jpg"), // 封面图
        title: "2019天津安防展圆满落幕 虹星科技虹膜采集建库定制设备大放异彩", // 标题
        time: "2019.05.15", // 时间
        desc:
            "5月10日，为期3天的2019第10届中国国际智慧城市暨社会公共安全产品（天津）展览会（Cipse安博会）在天津国际展览中心圆满落下帷幕。本次展会展出总面积近20,000平方米，200多家国内外安防产业企业参展，共吸引约20,000名来自相关领域的政府领导、专家学者、企业高管、城市应急救援、应急管理机构、房地产商、物业公司、工程商、采购商等专业人士和各界精英到场进行行业交流与贸易采购。", // 封面描述
        content: [
            {
                type: "img",
                inner: require("@/assets/img/news/201905150900/1.jpg"),
                desc: "2019天津安防展虹星科技展台",
            },
            {
                type: "text",
                inner:
                    "5月10日，为期3天的2019第10届中国国际智慧城市暨社会公共安全产品（天津）展览会（Cipse安博会）在天津国际展览中心圆满落下帷幕。本次展会展出总面积近20,000平方米，200多家国内外安防产业企业参展，共吸引约20,000名来自相关领域的政府领导、专家学者、企业高管、城市应急救援、应急管理机构、房地产商、物业公司、工程商、采购商等专业人士和各界精英到场进行行业交流与贸易采购。",
            },
            {
                type: "text",
                inner:
                    "其中，虹星科技作为虹膜人脸融合识别在安防领域的领军企业亮相了本次展会，携带的以虹膜人脸信息采集、中距离+壁挂式虹膜注册识别、远距离+多模态虹膜融合识别等多款混合生物识别设备及相应行业应用方案组成的智慧安防身份验证系统矩阵，成为本次天津安防展上最亮眼的一道风景线。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201905150900/2.jpg"),
                desc: "聆听虹星工作人员讲解的参展领导",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201905150900/3.jpg"),
                desc: "聆听虹星工作人员讲解的参展领导",
            },
            {
                type: "text",
                inner:
                    "占据了虹星展台C位的S300-UC桌面式虹膜人脸信息采集设备及W200手持式虹膜人脸信息采集设备，无疑成了这次展会当之无愧的人气王。这两款专为虹膜采集建库定制的虹膜人脸信息采集设备，前不久才通过相关部门的第一批虹膜采集检测，可通过建立违法犯罪人员虹膜图像信息统一数据规范和建库规范，构建全国范围的虹膜识别统一服务云平台，为各业务领域奠定虹膜的基础数据支撑。",
            },
            {
                type: "text",
                inner:
                    "虹星的S300-UC与W200这两款高端虹膜人脸信息采集装置，具有贴合面部及眼部采集习惯的人体工程学结构设计，体积轻便易用，可实现秒级的注册和识别，并获取远超ISO和国内安防虹膜图像质量标准的高清虹膜图像，适合各种复杂环境下大规模人群数据采集。该采集装置在隐蔽式识别、大型活动会议、社会单位身份识别、互联网+可信身份认证等领域均有广阔的应用前景。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201905150900/4.jpg"),
                desc: "虹星科技展位上的参展观众",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201905150900/5.jpg"),
                desc: "虹星科技展位上的参展观众",
            },
            {
                type: "text",
                inner:
                    "在这次展会上同样大放其彩的S320壁挂式虹膜人脸识别一体机，就是虹星科技在中距离虹膜识别范围内，完美杂糅技术、产品、体验的集大成者。45~65cm的识别距离，贴合人的用眼习惯，相机通过AI算法可根据用户身高与距离实现自动调整，快速准确的抓取高质量人脸和虹膜图像，满足高安全、高易用性的身份认证需求。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201905150900/6.jpg"),
                desc: "虹星科技虹膜采集建库定制设备",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201905150900/7.jpg"),
                desc: "虹星科技中距离壁挂式虹膜人脸识别一体机",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201905150900/8.jpg"),
                desc: "虹星科技远距离+多模态虹膜人脸识别产品",
            },
            {
                type: "text",
                inner:
                    "虹星科技始终在致力研发推广中国制造的适用的、好用的、易用的高性价比中远距离虹膜人脸融合识别产品不断发力，以争当无证精准身份识别新时代领导者为目标不断前行。",
            },
            {
                type: "text",
                inner:
                    "接下来，虹星科技也将马不停蹄地参加5月16日在天津梅江会展中心举办的2019第三届世界智能大会，作为中科院自动化所技术产业化的企业代表与世界智能领域交流，展现最前沿的生物识别新成果，届时也欢迎各位的莅临梅江会展中心N1馆C01展位参观！",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201905150900/9.jpg"),
                desc: "2019第三届世界智能大会虹星科技展台N1-C01",
            },
        ],
    },
    {
        imgPo: "imgLeft", // 图片的位置，左或者右-11
        en: false, // 是否有英文翻译
        img: require("@/assets/img/news/201906060900/1.jpg"), // 封面图
        title: "天津滨海新区副区长张国盛莅临虹星科技指导帮扶", // 标题
        time: "2019.06.06", // 时间
        desc:
            "5月29日下午，天津滨海新区副区长张国盛带领，由滨海新区卫生健康委副书记李艳梅同志、区发改委王光军同志等组成的包联帮扶小组，莅临天津中科虹星科技有限公司（以下简称“虹星科技”）开展包联帮扶企业和调研活动，深入基层，了解企业发展情况。", // 封面描述
        content: [
            {
                type: "img",
                inner: require("@/assets/img/news/201906060900/1.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "5月29日下午，天津滨海新区副区长张国盛带领，由滨海新区卫生健康委副书记李艳梅同志、区发改委王光军同志等组成的包联帮扶小组，莅临天津中科虹星科技有限公司（以下简称“虹星科技”）开展包联帮扶企业和调研活动，深入基层，了解企业发展情况。",
            },
            {
                type: "text",
                inner:
                    "张国盛副区长一行先参观了虹星科技公司一楼展厅，听取了虹星科技主要负责人对于虹星科技技术亮点、拳头产品和新厂房规划的详细汇报。接下来，张国盛副区长在公司二楼会议室主持召开了座谈，与虹星科技主要负责人及骨干人员进行了当面交流。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201906060900/2.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "张国盛副区长指出，当前新区正深入开展“双万双服促发展”活动，进一步优化营商环境，培育经济发展新动能，推动经济高质量发展，只有企业发展好了，新区才能取得更好地发展。对于企业提出的问题，要抓紧时间，帮助企业与相关职能部门对接，逐一落实解决，及时跟踪反馈，加大服务力度；企业自身也要练好内功，提高竞争力，新区将提供更广阔的舞台，更公平的竞争环境，使企业在滨海新区更茁壮地成长。对于虹星科技提出的希望政府协助对接应用场景的诉求，张国盛副区长当即要求，政府办安排“泰达智慧城市工作组”与虹星科技对接，测试虹星产品；区发改委安排天津港与中科虹星科技对接，沟通虹膜识别技术应用情况。",
            },
            {
                type: "text",
                inner:
                    "包联帮扶小组亲民爱民、雷厉风行的工作作风给虹星科技的工作人员留下了极其深刻的印象，也感受到了滨海新区双万双服活动为企业带来的盎然生机与活力，期盼虹星科技早日有施展拳脚的机会，为滨海新区的蒸蒸日上贡献力量。",
            },
        ],
    },
    {
        imgPo: "imgLeft", // 图片的位置，左或者右-10
        en: false, // 是否有英文翻译
        img: require("@/assets/img/news/201906110900/1.png"), // 封面图
        title: "虹星科技采集设备过检：虹膜建库不二选", // 标题
        time: "2019.06.11", // 时间
        desc:
            "迈入人工智能时代，我们在感受社会高速发展的便利同时，也深受信息窃取、资金盗刷、各式新型网络诈骗的困扰。面对“魔高一尺”的犯罪分子，自然传统依靠证件、照片等信息对人员身份认证的方法已无法满足需求，虹膜等高精度的生物特征识别手段正成为实战中保持“道高一丈”的致胜法宝。", // 封面描述
        content: [
            {
                type: "img",
                inner: require("@/assets/img/news/201906110900/1.png"),
                desc: "高精度的虹膜识别正成为高效刑侦的新需求齐",
            },
            {
                type: "text",
                inner:
                    "迈入人工智能时代，我们在感受社会高速发展的便利同时，也深受信息窃取、资金盗刷、各式新型网络诈骗的困扰。面对“魔高一尺”的犯罪分子，自然传统依靠证件、照片等信息对人员身份认证的方法已无法满足需求，虹膜等高精度的生物特征识别手段正成为实战中保持“道高一丈”的致胜法宝。",
            },
            {
                type: "text",
                inner:
                    "2019年4月18日,相关部门在广东珠海召开全国刑事技术新技术新装备推广会，孙劲峰副局长、王海欧处长以及各省、自治区、直辖市负责人参加会议, 并遴选出来自虹膜识别、声纹识别两大领域共二十多家优秀企业参会，讨论虹膜识别和声纹识别在全国刑侦系统的推广应用，虹星科技作为国内远距离虹膜人脸融合识别的领导者也赴会出席。",
            },
            {
                type: "text",
                inner:
                    "同期，相关部门向全国范围内符合资质的虹膜识别产品供应商进行了虹膜采集设备送检征召，近几周质检中心检测结果出炉，虹星科技此次送检的专为虹膜采集建库定制的虹膜人脸信息采集设备——W200手持式虹膜人脸信息采集设备及S300-UC桌面式虹膜人脸信息采集设备，完全符合《用于刑事侦查业务的虹膜采集设备技术要求》（用于千万级刑专子系统虹膜库建设）的各项指标要求，成功过检并入选合格产品及相关部门《虹膜数据采集终端合格产品及制造商名录》。",
            },
            {
                type: "title",
                inner: "虹膜人脸融合：为虹膜采集建库而生",
            },
            {
                type: "text",
                inner:
                    "我国已相继立法在社会保障、二代居民身份证、电子护照、出入境管理等关键领域采用生物特征识别技术，公民生物特征数据库建设上升为全球各国重要战略手段，并应用于国家安全、社会治安管理等各领域。据统计，目前中国居民身份证指纹数据量达4亿，违法犯罪人员指纹采集达数千万，身份证人像数据达15亿，全国机关DNA数据库约6000多万。",
            },
            {
                type: "text",
                inner:
                    "而虹膜识别技术作为现有最安全、精准的生物识别技术，在国土安全、社会安全等高安全需求场景正日益发挥越来越重要的作用，虹膜生物特征身份信息库的建设工作亟待开展。这类应用环境下一般距离较远，并且设备安装隐蔽、无法要求人的配合，需要虹膜识别向远距离、非配合方向发展。",
            },
            {
                type: "text",
                inner:
                    "虹膜建库是虹膜识别规模化应用的坚实基础，目标是为各级机关提供虹膜身份核验的统一出入口。只有先建立全国统一的虹膜原始图像数据库，依据图像质量标准各地采集到图像经检查合格后入库，随后才能在重点场所建立试点，加快面向公共安全应用的产品定制和应用推广，结合公关部门的应用需求，及时开展规模化应用。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201906110900/2.jpg"),
                desc: "虹星科技的两款虹膜人脸信息采集设备",
            },
            {
                type: "text",
                inner:
                    "虹星科技的S300-UC与W200这两款高端虹膜人脸信息采集装置，支持固定式/便捷式采集，固定场所或现场采集均可灵活使用，具有贴合面部及眼部采集习惯的人体工程学结构设计，体积轻便易用，可实现秒级的注册和识别，采集设备高度集成，可实现护照/身份证、人脸、虹膜等多模态身份信息采集，适合各种复杂环境下大规模人群数据采集。",
            },
            {
                type: "text",
                inner:
                    "区别于市面其他虹膜识别厂家，孵化于中科院自动化所模式识别国家重点实验室的虹星科技，在技术研发上始终保持着团队10年远距离虹膜识别应用深耕经验和15年视觉成像处理研发管理和实践基础的传承创新，在产品上坚持虹膜人脸融合的多模态面部采集识别模式。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/201906110900/3.jpg"),
                desc: "虹星科技远距离虹膜识别技术入选《科技日报》“2018年中国十大突破技术",
            },
            {
                type: "text",
                inner:
                    "倚靠中科院自动化所过硬的研发背景，以及自身过硬的技术开发能力，虹星科技的远距离虹膜人脸融合识别技术在国内吸睛无数，不但获得《中国科学报》头版头条刊载及《中国经济时报》的专版报道，更荣膺《科技日报》评选的“2018年中国十大突破技术”，成为打破国际巨头垄断、坚持民族品牌自主研发、引领生物特征识别行业创新的国产企业代表。",
            },
            {
                type: "text",
                inner:
                    "虹星科技在为虹膜采集建库量身定制产品时也同样考虑到虹膜采集识别与人脸采集识别的互补性与紧密关联性，利用虹膜人脸信息一体采集的优势，为虹膜识别库建库预留下人脸建库的接口与空间，保障了在固定场所进行虹膜采集时便于与证件比对，绑定注册人员的身份信息，节省人力的同时提高采集效率，可谓名副其实的专为“虹膜采集建库”而生了。",
            },
            {
                type: "title",
                inner: "虹膜图像质量：国内牵头人与国际领先者",
            },
            {
                type: "text",
                inner:
                    "虹膜图像质量评价技术和系统是入库虹膜图像质量的重要把控点，但建库用虹膜图像质量评价算法与传统的虹膜图像质量算法不同。通常，虹膜采集设备中的质量评价算法面向一个虹膜图像序列，并且与自身的识别算法密切相关。而建库用虹膜图像质量评价算法旨在保障入库虹膜图像的质量，面向不同的虹膜采集设备获得的静态虹膜图像，并且数据量巨大。",
            },
            {
                type: "text",
                inner:
                    "NIST（美国国家标准与技术研究院）组织的IQCE测试表明，应用图像质量在前15%的虹膜图像进行识别比图像质量在后15%的虹膜图像，识别性能能够高出10倍。由此可见，虹膜图像质量与虹膜识别性能密切相关。因而，在虹膜采集建库时保证入库图像质量，对于后续识别应用具有非常关键的作用。",
            },
            {
                type: "text",
                inner:
                    "相较之下，虹星科技则在虹膜采集成像上具备天然优势，其送检的S300-UC与W200这两款高端虹膜人脸信息采集装置不仅在光源波长、设备分辨力检验、虹膜采样分辨率、灰度等级、灰度等级利用率、虹膜半径、虹膜与巩膜对比度检验、虹膜与瞳孔对比对检验、虹膜有效区域占比、边界裕量等各项量化指标上完全满足《用于刑事侦查业务的虹膜采集设备技术要求》，远优于行业通用的《GAT1429-2017安防虹膜识别应用 图像技术要求》、《GB／T 35783-2017 信息技术 虹膜识别设备通用规范》要求，采集的图像质量优异且稳定可靠。",
            },
            {
                type: "text",
                inner:
                    "与此同时，虹星科技在参与国内虹膜标准制定、推进产业及生态合作方面取得了多项成果。虹星科技的技术总监李海青博士更是多项国家和行业虹膜标准的主要起草人，目前更带领着虹星团队牵头并深度参与制定更多的国家虹膜标准。除去在国内虹膜图像标准上的话语权，虹星科技的虹膜算法在与国际顶级虹膜识别厂商相比也毫不逊色。在NIST组织的第9次虹膜识别技术测试IREXIX中，虹星科技核心算法团队提交的算法在1:1匹配测试中取得1.2%的错误不匹配率@百万分之一的错误匹配率，在1:N（数据库注册人数N高达16万）辨认测试中取得2%的拒识率@万分之一的误识率，识别精度超IrisID（国际少数具有近中远虹膜识别产品公司）、高通等国际一线厂商。",
            },
            {
                type: "title",
                inner: "虹膜数据加密：保障公民隐私的防火墙",
            },
            {
                type: "text",
                inner:
                    "虹膜原始图像是个人隐私数据的集中体现，正常的虹膜信息采集，应通过信息网/互联网络/便捷式存储媒介，按照安全模式，传输、传送图像特征到中心数据库。但由于过程中存在采集、传输、入库、比对等多个环节，还是存在隐私泄露的风险，印度虹膜身份证项目中就出现过大量公民虹膜数据泄露事件，造成了严重的负面社会影响。",
            },
            {
                type: "text",
                inner:
                    "为了预防此类虹膜应用安全隐患，虹星科技也制定了一套强有力的基于密码学的原始图像和特征模板保护方案，利用数据加密手段将密钥和图像/特征信息相绑定，生成密文进行传输，在起到隐私数据保护的目的，对虹膜数据进行安全性保护，以满足用户在身份采集、存储和认证过程中对隐私保护的安全性需求，成为保障公民隐私最坚实的一道防火墙。",
            },
            {
                type: "text",
                inner:
                    "可以预见，国内虹膜数据库建成后，在全国范围内形成有效的犯罪嫌疑人检索、查询系统，有效杜绝嫌疑人假冒身份的现象，虹星科技的虹膜人脸信息采集设备也将在隐蔽式识别、大型活动会议、社会单位身份识别、互联网+可信身份认证等领域均有广阔的应用前景，引领亿级面部多模态识别。目前，虹星科技为满足虹星当前研发和生产等业务需求，已在天津建立面积1300㎡的生产基地并配备相关人员，为目前的客户群提供更强大的三年质保及售后支持。",
            },
            {
                type: "text",
                inner:
                    "伴随着虹膜采集的试点开展，未来的全民虹膜采集也不将只是纸上谈兵。如果中国拥有13亿人口的虹膜数据库，很多生活场景也将可快速使用虹膜识别，借着5G与物联网的东风，虹膜识别将展现出更多用武之地，势必将成为下一个改变社会生活的重要科技拐点。届时，身为远距离虹膜人脸融合识别开创者与领导者的虹星科技，在披荆斩棘后如何又将乘风破浪，带领人们走向怎样的未来彼端，我们翘首以盼！",
            },
        ],
    },
    {
        imgPo: "imgLeft", // 图片的位置，左或者右
        en: false, // 是否有英文翻译
        img: require("@/assets/img/news/20180416/1.jpg"), // 封面图
        title: "CBRE2018国际生物识别技术展览会：虹星科技多款混合生物识别设备广获好评", // 标题
        time: "2018.04.16", // 时间
        desc:
            "11月20日，由天津市科学技术局主办，天津科技融资控股集团有限公司承办的天津市首批雏鹰、瞪羚企业发布会在天津召开，天津市副市长连茂君及各区政府分管领导等参会。", // 封面描述
        content: [
            {
                type: "img",
                inner: require("@/assets/img/news/20180416/1.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "2018年4月2日至4日，CBRE2018第三届国际生物识别技术展览会暨高峰论坛在上海新国际博览中心盛大开启。作为展示全球生物识别产业最新产品技术的国际级平台，也是国内唯一专业的生物识别展会，CBRE2018汇集了世界各地虹膜识别、指纹识别、指静脉识别、人脸识别、声纹识别、语音识别、步态识别、指纹芯片等上下游产业，参展的业内顶级企业逾百家，共吸引来自30多个国家20000多名专业观众莅临。",
            },
            {
                type: "text",
                inner:
                    "其中，虹星科技作为智能识别行业的佼佼者也亮相了此次展会，携带的多款混合生物识别设备与应用方案，更博得了诸多参会者的青睐与征询。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20180416/2.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "致力于引领国内生物识别研发应用的创新驱动者，虹星科技首创“人证+活体+虹膜”多模态高精度生物特征识别产品，在会展期间可谓是不折不扣的人气王，引得现场观众竞相体验。无论是W200手持式虹膜人脸信息采集设备的信息便捷录入与即时高清成像，S200G系列三合一智能闸机的秒速识别开闸和防冲撞防碰伤，S200P混合生物特征识别一体机的高颜值外形及加密私有云，都给大部分体验者留下了极深的印象，赢获好评一片。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20180416/3.jpg"),
            },
            {
                type: "text",
                inner:
                    "生物识别技术发展到如今，已按不同的识别介质细化了多种品类，并衍生出相应产品，相继进入了人们的视野和生活。但作为目前安全性和准确性最好的生物特征识别方案，虹膜识别此前受限于距离上的技术难题，未大规模在应用领域投入使用。",
            },
            {
                type: "text",
                inner:
                    "而虹星科技以改革者的姿态应运而生，攻克远距离虹膜识别这块技术上的硬骨头，辅之以智能三维人机交互软件，填补了整个行业的空白，成为目前生物识别商业化道路的领跑者，也将重新定义未来人类的全新生活方式。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20180416/4.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "在本届CBRE2018展会上，虹星科技的三款产品——W200、S200G和S200P也深受参展人士的欢迎，取得了十分亮眼的表现，预示着虹星科技的多模态生物识别产品已经逐渐走向了成熟，未来的发展也更加让人期待。",
            },
        ],
    },
    {
        imgPo: "imgLeft", // 图片的位置，左或者右
        en: false, // 是否有英文翻译
        img: require("@/assets/img/news/20180418/1.jpg"), // 封面图
        title: "美国NIST虹膜识别算法最新测试结果出炉 虹星科技成绩骄人", // 标题
        time: "2018.04.18", // 时间
        desc:
            "11月20日，由天津市科学技术局主办，天津科技融资控股集团有限公司承办的天津市首批雏鹰、瞪羚企业发布会在天津召开，天津市副市长连茂君及各区政府分管领导等参会。", // 封面描述
        content: [
            {
                type: "img",
                inner: require("@/assets/img/news/20180418/1.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "4月18日，美国国家标准与技术研究院（National Institute of Standards and Technology，简称NIST）组织的第9次虹膜识别技术测试IREX IX结果出炉，天津中科智能识别产业技术研究院虹膜识别团队（即虹星科技核心算法团队）提交的算法在1:1及1:N两项精准度测试中均取得优异结果，识别精度超IrisID、高通等国际一线厂商。",
            },
            {
                type: "text",
                inner:
                    "据悉，本次NIST组织的IREX IX虹膜识别算法测试中，共有包括NEC、高通、NeuroTechnology、DeltaID、IrisID等世界知名厂商在内的13家单位提交了算法，参与单位数量为IREX史上最多。本次IREX IX共测试了46个算法，测试数据均源自2007年至2015年在不同地点采集的真实应用数据，其中包含26万人的约70万张图像。以Tafirt为代号的天津中科智能识别产业技术研究院于2016年10月至2017年9月提交三次算法，在1:1匹配测试中取得1.2%的错误不匹配率@百万分之一的错误匹配率，在1:N（数据库注册人数N高达16万）辨认测试中取得2%的拒识率@万分之一的误识率，显著领先同参与IREX IX测试的IrisID、高通等国际一线厂商。",
            },
            {
                type: "text",
                inner:
                    "最新结果将于近期在NIST IREX IX主页（https://www.nist.gov/itl/iad/image-group/irex-ix）上公布。目前，作为天津中科智能识别产业技术研究院孵化的高科技企业，虹星科技正专注于开发大规模1:N场景下的多模态虹膜识别产品，力求将自身国际前沿的科研理论应用在更多的现实交互场景中。",
            },
        ],
    },
    {
        imgPo: "imgLeft", // 图片的位置，左或者右
        en: false, // 是否有英文翻译
        img: require("@/assets/img/news/20180430/1.jpg"), // 封面图
        title: "虹膜识别：“眼球经济”的未来蓝海", // 标题
        time: "2018.04.30", // 时间
        desc:
            "近日，好莱坞大导演斯皮尔伯格执导的科幻新片《头号玩家》在国内热映，内地票房也已突破10亿大关，相关话题更是成为一时谈资，各路讨论也刷遍了许多人的朋友圈。而将故事设定在2045年的沉浸式全触感VR世界的超现实电影中，反派Boss竟因随手放置记录密码的纸条导致虚拟角色被黑功亏一篑，此处的剧情“BUG”也遭来部分非议——要知道即便倒退回信息安全技术迈入生物识别转型的2018年，仅依靠虹膜识别手段一项就能将妄图冒名顶替的侵入者拒之门外。。", // 封面描述
        content: [
            {
                type: "text",
                inner:
                    "近日，好莱坞大导演斯皮尔伯格执导的科幻新片《头号玩家》在国内热映，内地票房也已突破10亿大关，相关话题更是成为一时谈资，各路讨论也刷遍了许多人的朋友圈。而将故事设定在2045年的沉浸式全触感VR世界的超现实电影中，反派Boss竟因随手放置记录密码的纸条导致虚拟角色被黑功亏一篑，此处的剧情“BUG”也遭来部分非议——要知道即便倒退回信息安全技术迈入生物识别转型的2018年，仅依靠虹膜识别手段一项就能将妄图冒名顶替的侵入者拒之门外。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20180430/1.jpg"),
                desc: "天津市副市长连茂君致辞发言",
            },
            {
                type: "title",
                inner: "载体变迁：身份认证编年史",
            },
            {
                type: "text",
                inner:
                    "纵观整个世界发展史，身份鉴别技术一直是人类常年致力研究的重要课题。上至国家管理层面，出现了唐朝的鱼符、明代的路引、清代的腰牌再到如今的身份证；下至民众财产安全，更是有先秦的印章、唐朝的铜钥、宋元的画押再到现在的电子U盾。但这些无外乎都是需随身携带的身外载体，使用过程中常因疏漏造成无法识别的尴尬局面。一旦遗失或被他人盗用，更可能酿成人身财产甚至社会安全的重大危机。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20180430/2.jpg"),
                desc: '中国最早"身份证": 鱼符',
            },
            {
                type: "text",
                inner:
                    "因此，如何利用自身载体数据——人体固有的生理特征（如人脸、指纹、虹膜、静脉、视网膜）及行为特性（如笔迹、声音、步态）来进行身份认证，便成了现代信息安全管理的核心环节，而虹膜识别被认为是最具潜力的生物特征识别技术。",
            },
            {
                type: "text",
                inner:
                    "虹膜是人体中最独特的结构之一，它位于瞳孔外的一个环形区域，被透明的角膜层覆盖，呈现出一种由很多腺窝、皱褶、色素斑等构成的复杂的放射状纹理。虹膜自胎儿发育阶段形成后直至死亡终生不变，且不因外部干扰而磨损变化，因此具有极强的唯一性和稳定性。通过虹膜识别，生理特征极为相似的同卵双胞胎也能在1s内进行区分，即便是要分辨《西游记》的“真假美猴王”也不再是个难题。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20180430/3.jpg"),
                desc: "虹膜",
            },
            {
                type: "text",
                inner:
                    "不同于传统生物测定技术只能读取13-16个单位，一个虹膜就有大约266个单位的读取点，因此相较于指纹0.8%、人脸识别2%左右的误识率，虹膜识别误识率可低至百万分之一，想出错都难。并且虹膜作为一个外部可见的内部器官，相对于需要接触感知的指纹、手形等生物特征，不必紧贴采集装置就能获取合格图像，可以说虹膜识别是目前最稳定、最准确、安全系数最高的生物识别技术。",
            },
            {
                type: "title",
                inner: "核心产权：中国自主研发之路",
            },
            {
                type: "text",
                inner:
                    "既然虹膜具有外部可见的特征，那么虹膜识别是否就是一个简单的图像采集→比对的过程呢？答案是否定的，从虹膜图像的获取到最终的身份匹配，不经过大量的专业计算是无法得以实现的。要保证虹膜识别在黑暗、强光等不同光照下，以及佩戴眼镜等条件下也能正常工作，搭载虹膜识别的设备需配备红外LED以及虹膜识别摄像头。首先红外LED发射红外线，虹膜识别摄像头透过红外线获取虹膜图案信息，对采集的图案信息进行处理编码，然后与预先设置存储的虹膜特征进行精准比对。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20180430/4.jpg"),
                desc: "虹膜采集",
            },
            {
                type: "text",
                inner:
                    "由于自主研发虹膜图像获取装置的技术门槛高，中国虹膜识别研究的开展一度受限。直到2000年中国科学院自动化研究所开发出虹膜识别核心算法，才拥有了国内第一套自己虹膜识别的核心知识产权。",
            },
            {
                type: "text",
                inner:
                    "而孵化于中科院自动化所谭铁牛院士团队的虹星科技，也在团队潜心钻研10年的长距离虹膜识别领域后，凭借智能三维人机交互和远距离虹膜识别两大核心技术，和拥有的40多项相关核心发明专利和软件注册权，于近期打造出全球具有“虹膜识别+活体检测+人证比对”功能产品，能在长达1米左右的距离对活体实现精准识别，迅速跻身为国内生物特征识别领域的领导者。",
            },
            {
                type: "title",
                inner: "市场受限：挣脱困境的“明日之星”",
            },
            {
                type: "text",
                inner:
                    "不得不承认的是，虹膜识别技术对于普通大众而言，依然属于比较陌生的领域。究其原因，这与虹膜识别多在煤矿等特殊场景中使用，还尚未得到全面广泛的应用有关。距离与价格是其步履维艰的两个重要因素：一、目前市面其他虹膜识别设备多为近距离虹膜识别产品，工作距离多不足40cm，要用户主动的去配合设备才能完成图像采集，相对于人脸识别用户体验较差；二、由于研发生产成本高昂，其他虹膜识别设备成本至少在几万元以上，接近人脸识别设备的三倍，难以大规模商用，让不少厂商望而却步。而拥有世界上规模最大的远距离虹膜识别研究团队的虹星科技，目前则正在全力攻克这些难题。",
            },
            {
                type: "text",
                inner:
                    "在识别距离上，虹星科技率先推出了国内商业化远距离虹膜识别产品，批量产品系列的识别距离达0.8-1.2米，为传统虹膜识别距离的4倍，简化了用户肢体配合步骤，极大提升了操作体验感。与此同时，虹星科技还研发出工作距离长达10米的虹膜识别技术，或将在未来投入量产。",
            },
            {
                type: "text",
                inner:
                    "在成本控制上，虹星科技采用前沿的计算+成像的人工智能框架，同时在硬件和算法上做整体优化，致力做出售价万元以内的商用远距离虹膜识别方案。现阶段，虹星科技对外提供的产品主要包括：标准版设备S200、旗舰版设备S200P、闸机S200G、二次开发模组S200M。目前产品标准版设备售价在万元左右，旗舰版产品售价高于万元，闸机只需在传统闸机上略加改造即可，可以适用于机场、地铁、高铁和边检等人流密度高，安全性要求高的公共场所。",
            },
            {
                type: "text",
                inner:
                    "但无论是何种生物识别，本身都属于模糊识别，即只能判断“有多像”，而无法确定“一定是”，即使在实验环境下可达到非常高的识别率，但在复杂的实际环境中，单一技术仍存在一定局限性，只有结合多种生物识别技术，才能实现身份识别的安全验证。",
            },
            {
                type: "text",
                inner:
                    "因此，虹星科技实际落地的的远距离虹膜识别产品，也是集虹膜识别、人脸识别、活体检测于一体的多模态识别产品，以远距离虹膜识别为主，人脸识别为辅。值得一提的是，虹星科技掌握的长距离虹膜识别技术，与人脸识别的工作距离处于重合区域，这意味着虹膜、人脸识别可同步进行，识别效果将叠加比对，精准度远超单一的虹膜、人脸同类识别产品。",
            },
            {
                type: "title",
                inner: "未来应用：生活方式的全面颠覆”",
            },
            {
                type: "text",
                inner:
                    "毋庸置疑，未来应用虹膜识别的产品将随处可见，小到街头安置的智能机，大到国家的居民身份证，都离不开这项技术。目前包括美国、欧洲、日本等在内的很多发达国家，尤其是国土安全、社会安全等高安全需求场景，虹膜识别其实早已广泛使用。尤其在虹星科技突破应用距离限制后，虹膜识别在改造人类未来生活方式上将大有可为。",
            },
            {
                type: "text",
                inner:
                    "对国人而言，第三代居民身份证或将是我们迎来虹膜识别浪潮的先机。据报道，政府目前已在研究相关政策的下发，今后人们在办理身份证时，很有可能除了照片信息，也会将个人虹膜信息添加进去。",
            },
            {
                type: "text",
                inner:
                    "事实上，印度身份证管理局(UIDAI)早在2010年9月开启的AADHAR身份识别项目，就融入了虹膜识别技术为11亿人提供12位的身份证明编号，编号可与个人手机号及银行账户绑定，公民通过互联网进入数据库进行身份识别和手机实时验证，同时享受医疗、社保、培训、电信等服务。该项目已覆盖印度90%以上的人口，是世界上最大的生物识别数据项目。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20180430/5.jpg"),
                desc: "印度办理身份证采集虹膜",
            },
            {
                type: "text",
                inner:
                    "在交通出行领域上，虹膜识别将全方位打破传统安检手段的桎梏。无论是机场、车站或是港口，都需要在应对庞大的客流的同时保障旅客的安全，现有的人工核查方式饱受诟病，旅客大规模滞留事件也层出不穷。而引入虹膜识别系统后，乘客的票务信息与证件信息都可与自身虹膜实现绑定，目光一扫轻松过关，短时间便可实现大批次通关，出行再也不用担忧延误卡关的状况。",
            },
            {
                type: "text",
                inner:
                    "在工作居住方面上，安全管理将上升到一个前所未有的全新层级。诸如办公楼宇、校园片区、住宅小区等门禁要求较严格的区域，利用虹膜识别进行出入人员管理，可保障白名单人员无证通行，并对未登记者或黑名单人员实时预警。除此之外，虹膜识别还可根据个人身份实行权限分配，管控档案室、实验室、会议室等重要区域的机密安全，学校考试中还能杜绝替考等作弊现象。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20180430/6.jpg"),
                desc: "门禁应用虹膜识别",
            },
            {
                type: "text",
                inner:
                    "在公共安全事务上，虹膜识别将令罪犯或潜在危险分子无处遁形。相关机关依托嫌犯采集/识别一体化系统、监狱虹膜门禁管理系统等，对外在关卡、检查站、人流聚集地等场所实行身份排查和电子追捕，对内在看守所、监狱、矫正中心等区域实行人员监管和出入管控。而在如火灾、地震等自然灾害或其他突发事件发生时，虹膜识别也可以帮助救援人员快速疏散人群，并第一时间对伤难者进行身份确认，避免事态扩大化，做到信息的及时通报与反馈。",
            },
            {
                type: "text",
                inner:
                    "在金融支付领域上，虹膜识别势将引领金融支付方式的全新变革。在中东部分地区，已有银行推出了ATM虹膜取款功能，配置虹膜识别模块的ATM机将扫描用户虹膜来进行身份认证交易。可以预想到，今后将实现真正的“无人银行”，人们只需要一双眼睛，就能轻松完成过去需要人工柜台才能完成的繁琐操作，进一步降低金融机构运营成本和客户办理业务的时间成本。在移动端支付领域，随着搭载虹膜识别系统的手机大批推向市场，届时不必再依附指纹按压和密码输入，只需要给手机摄像头一个“深情款款”的眼神，就能开启一段支付的全新支付体验。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20180430/7.jpg"),
                desc: "虹膜识别手机",
            },
            {
                type: "text",
                inner:
                    "预见到虹膜识别对未来生活的全方位渗透，虹星科技也已积极与各产业先行者开展洽谈合作，目前已与机器人、金融、互联网、零售、房地产等行业的近百家领军企业建立合作关系，为其提供精准智能识别及大规模视觉数据采集、大规模身份信息管理等整套解决方案。这也是虹星科技一直以来不懈追求的企业愿景，即铸就国际一流、国内最大规模、最安全的智能识别数据库，真正构建智慧城市、平安城市，向每一位公民提供最精准、最安心的保障。",
            },
            {
                type: "text",
                inner:
                    "回溯国内的虹膜识别发展道路，是中科院自动化研究所开启了自主研究从无到有的崭新局面，并在计算机视觉与模式识别上辛勤耕耘近20年。如今传承中科院自动化所薪火的虹星科技，未来将在虹膜识别领域开创出怎样的新天地，我们翘首以盼。",
            },
        ],
    },
    {
        imgPo: "imgLeft", // 图片的位置，左或者右
        en: false, // 是否有英文翻译
        img: require("@/assets/img/news/20180525/1.jpg"), // 封面图
        title: "远距离虹膜与人脸融合识别，才是真正的多模态", // 标题
        time: "2018.05.25", // 时间
        desc:
            "11月20日，由天津市科学技术局主办，天津科技融资控股集团有限公司承办的天津市首批雏鹰、瞪羚企业发布会在天津召开，天津市副市长连茂君及各区政府分管领导等参会。", // 封面描述
        content: [
            {
                type: "text",
                inner:
                    "“对于提升用户生物特征识别的交互体验，我认为单纯优化某个技术环节无法提升整体表现。比如，用户信息采集到识别整个过程要在两秒内完成，如果你只是单方面提升某个环节的技术，最终获得的效果往往不理想。”虹星科技CEO兼创始人侯广琦指出。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20180525/1.jpg"),
                desc: "",
            },
            {
                type: "title",
                inner: "以远距离虹膜识别技术作为创业的第一道壁垒",
            },
            {
                type: "text",
                inner:
                    "侯广琦有着非常深厚的技术背景，在中科院自动化研究所学习阶段，从前端成像、中间的图像处理到后端的模式识别，他都有深入的了解和积累。",
            },
            {
                type: "text",
                inner:
                    "“博士后毕业，我既可以做前端设备，也可以做中间的软件处理和后面的模式识别。幸运的是，这段教育经历和虹星现在的业务不谋而合。”",
            },
            {
                type: "text",
                inner:
                    "2011年，侯广琦开始接触远距离虹模识别技术，并一头扎了进去，一做就是7年。作为国家级重大远距离虹膜识别项目的技术负责人，侯广琦对这项技术有着非常深入和全面的了解：“在研究的过程中，我发现这项技术有着几大特点：技术本身过于新颖，科研方面难点众多，研究开发人员较少，经费投入比较大。”",
            },
            {
                type: "text",
                inner:
                    "经历了多年的迭代，侯广琦对于团队在远距离虹膜识别技术上的实力非常自信，但同时他也在思考如何让这项前沿科研技术真正落地。",
            },
            {
                type: "text",
                inner:
                    "“一方面，在生活中，我常常被忘带证件而无法过安检闸机所困扰，这给我带来了灵感和思考；另一方面，针对这一麻烦，我们基于远距离虹膜识别提出的解决方案被合作企事业单位认可，这让我看见了市场里的机会。”",
            },
            {
                type: "text",
                inner: "于是，侯广琦把整个工程团队“忽悠”出来。就这样，虹星科技诞生了。",
            },
            {
                type: "title",
                inner: "方案的每个技术环节都“应用自如”",
            },
            {
                type: "text",
                inner:
                    "如果说远距离虹膜识别技术是虹星科技足以炫耀的闪光点，那么全产品线技术研发能力则是它实实在在的优势。",
            },
            {
                type: "text",
                inner:
                    "“为了解决应用场景中存在的问题，我们不仅可以从技术优化、算法上找到提升的可能性，同时从硬件，包括光学成像上，都能够找出商业解决办法。我们做的是系统级的提升。",
            },
            {
                type: "text",
                inner:
                    "事实确实如此。从电路设计、机械结构，到软件算法，虹星科技都具备足够的设计和研发能力，这不仅让其可以最大程度缩短生产周期，迅速响应客户，也让它在优化计算机视觉整体解决方案上更加得心应手。",
            },
            {
                type: "text",
                inner:
                    "“其中，我们最为看重的就是远距离虹膜识别技术、三维成像和交互技术。”侯广琦指出，这两种技术的价值就体现在用户的身份能够被高精准的识别出，同时在一定程度上增加了便利性和识别速度。",
            },
            {
                type: "text",
                inner:
                    "“比如用户不用拿出证件，就可以迅速过闸机，这样整个过程的交互体验会更好。同时也会增强一定的安全性，让别人无法伪造自己。”",
            },
            {
                type: "text",
                inner:
                    "当然，亦如侯广琦一直强调的，要想做到这样良好的交互体验，单纯依赖一两种优势技术是不行的，所以在前端成像方面，虹星科技也是下足了功夫。",
            },
            {
                type: "text",
                inner:
                    "“在前端成像层面，我们的前端处理算法都是依据成像的物理架构进行优化的，所以从前端进来的数据都是经过处理和清洗后的数据，而不是单纯的数据传输。除此之外，我们还把前端智能处理与后端模式识别算法相匹配，这样就形成了整套系统。”侯广琦解释道。",
            },
            {
                type: "text",
                inner:
                    "而为了让系统落到实处，虹星科技最终以闸机和立柱版两款产品形态落实和呈现了解决方案。",
            },
        ],
    },
    {
        imgPo: "imgLeft", // 图片的位置，左或者右
        en: false, // 是否有英文翻译
        img: require("@/assets/img/news/20180611/1.jpg"), // 封面图
        title: "泰国海关总局代表团莅临虹星科技参观 体验远距离虹膜融合识别黑科技", // 标题
        time: "2018.06.11", // 时间
        desc:
            "5月25日至6月1日，泰国海关总局应中华人民共和国海关总署邀请，派遣代表团到访中国，开展了为期7天的中泰ICT产业交流之行。泰国海关总局代表团参观考察了包括AI解决方案和生物识别领域、风险管理、大数据、物流监控、电子商务平台在内的多家中国顶尖高新技术企业。作为国内虹膜识别领军企业，虹星科技也荣邀到泰国海关总局代表团亲自莅临公司参观考察。", // 封面描述
        content: [
            {
                type: "text",
                inner:
                    "5月25日至6月1日，泰国海关总局应中华人民共和国海关总署邀请，派遣代表团到访中国，开展了为期7天的中泰ICT产业交流之行。泰国海关总局代表团参观考察了包括AI解决方案和生物识别领域、风险管理、大数据、物流监控、电子商务平台在内的多家中国顶尖高新技术企业。作为国内虹膜识别领军企业，虹星科技也荣邀到泰国海关总局代表团亲自莅临公司参观考察。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20180611/1.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "5月30日上午8点30分，泰国海关总局代表团成员——泰国海关总局副局长威差•官提蒙迪（Auychai Kultipmontre）、泰国信息通信技术司司长杰沙达•阿里亚查官（Jedsada Ariyachatkul）、泰国信息通信技术司规划与标准化处处长威拉萨•罗赛欧（Weerasak Loysai-or）及泰国电脑技术员代表他纳瓦•崇普旺（Thanawat Chumphuwang）等一行4人，来到虹星科技位于北京海淀区花园路的产品展厅，参观了解远距离虹膜融合识别产品的技术优势及实际解决方案。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20180611/2.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "代表团在虹星科技创始人侯广琦的陪同下，相继参观了公司的办公区、研发中心、硬件中心和产品展览厅。在展示厅现场，侯广琦博士向其介绍了团队自主研发的远距离虹膜融合识别技术，并演示了如何运用W200手持式设备采集虹膜人脸信息，并模拟了无人超市场景下利用S200P旗舰版实现智能购物支付，以及高安保场所使用S200G智能闸机实现出入权限管控等操作。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20180611/3.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "“在随后的交流座谈会上，泰国海关总局代表团认真听取了虹星科技技术研发总监李海青的报告，代表就自身关心的虹星在产品升级、业务发展、技术难点、项目应用等方面问题进行了咨询。泰国海关总局副局长威差•官提蒙迪高度肯定了虹星科技的多模态融合识别产品，并鼓励虹星科技继续扮演好科研创新者的角色，推进远距离虹膜识别在社会实践中的创新推广。”",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20180611/4.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "会后，双方代表一同面对镜头合影留念，泰国海关总局代表团更将官方纪念币赠予虹星科技留念。威差•官提蒙迪表示，此次交流把中泰ICT产业交流和合作提升到一个新的层次，希望未来更好地发挥两国技术优势，并对远距离虹膜识别促进两国海关业务转型寄予厚望。”",
            },
        ],
    },

    {
        imgPo: "imgLeft", // 图片的位置，左或者右
        img: require("@/assets/img/news/20180711/1.jpg"), // 封面图
        title: "跟虹膜识别一起玩混搭，开创智能出行e时代", // 标题
        time: "2018.07.11", // 时间
        desc:
            "提起张学友，想必许多人脑中立刻响起了那首经典的“你好毒，你好毒，你好毒呜呜呜”。谁又能想到，如今忙着开世界巡回演唱会的张学友，也成了追逃缉凶的“毒”门利器。难挡歌神魅力的不只普通歌迷，连在逃嫌疑犯们都纷纷赶去听他的演唱会，让蹲守在在安检口的警方来了个瓮中捉鳖。据公开报道，从4月到7月，在各地守株待兔的警方，分别在张学友演唱会南昌站、赣州站、嘉兴站、金华站、洛阳站、威海站均成功控制逃犯。学友“神探”不但轻松拿下八杀成就，也为在抓逃中大显身手的智能身份识别设备打了一波活广告。", // 封面描述
        content: [
            {
                type: "text",
                inner:
                    "提起张学友，想必许多人脑中立刻响起了那首经典的“你好毒，你好毒，你好毒呜呜呜”。谁又能想到，如今忙着开世界巡回演唱会的张学友，也成了追逃缉凶的“毒”门利器。难挡歌神魅力的不只普通歌迷，连在逃嫌疑犯们都纷纷赶去听他的演唱会，让蹲守在在安检口的警方来了个瓮中捉鳖。据公开报道，从4月到7月，在各地守株待兔的警方，分别在张学友演唱会南昌站、赣州站、嘉兴站、金华站、洛阳站、威海站均成功控制逃犯。学友“神探”不但轻松拿下八杀成就，也为在抓逃中大显身手的智能身份识别设备打了一波活广告。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20180711/1.jpg"),
                desc: "图 | 智能身份识别系统在现代出行中的应用",
            },
            {
                type: "title",
                inner: "车牌识别：便利与尴尬共存",
            },
            {
                type: "text",
                inner:
                    "在日常出行中，我们目前接触较多的智能识别设备，主要分为物体检测和生物识别两大类。物体检测设备，除了地铁、车站、机场必备的安检机和安检门外，车牌识别系统也早已进入了人们视野，目前广泛应用于公路收费、停车管理、执法稽查等场景，实属智能出行时代带来的重大便利。",
            },
            {
                type: "text",
                inner:
                    "然而，由于车牌识别系统仍存在不少技术弊端，导致了不少尴尬场景的发生：座驾到门禁处屡屡被拒识，着急停车或离开的车主只能干瞪眼；机器认车不认人，爱车被他人直接开走也无处申冤；记录管理有漏洞，查出了假牌套牌也难以追溯……同时，这些缺陷也给车辆监管带来了诸多不便，欧洲数次见诸报端的汽车冲撞人群事件，便是警方在大规模集会活动中，无法强效统一管理车辆和驾驶人员，为恐怖分子提供可趁之机而酿成的悲剧。",
            },
            {
                type: "text",
                inner:
                    "史军表示，背靠扎实的科研力量与原创深度学习平台，商汤科技去年收获了几倍的增长，墩实了市场领先地位。更为有说服力的是，在行业宽度明显超过友商的情况下，人均收入同样行业领先，体现了商汤算法和平台的通用性、先进性。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20180711/2.jpg"),
                desc: "图 | 单一车牌识别系统时有尴尬发生",
            },
            {
                type: "text",
                inner:
                    "这些现今出行管理上的短板看似难以解决，但一旦引入生物识别技术作补充，将活体特征与物件数据实现绑定，人车信息互通且双向并行，那么一切问题都将迎刃而解。",
            },
            {
                type: "title",
                inner: "虹膜识别：新出行时代最优选",
            },
            {
                type: "text",
                inner:
                    "智能出行系统结合生物识别技术，看似是牛奶加咖啡的完美搭档，要做到相辅相成合作共赢，还真得狠下一番功夫。尽管生物识别种类繁多，但要找到一个能与智能出行打配合战的小伙伴，也绝非易事。",
            },
            {
                type: "text",
                inner:
                    "就拿大部分人都关心的私家车自驾来说，出行要契合对应的车牌识别系统，这项生物识别技术必须具备唯一、稳定、非接触、高精度、防伪造、高速识别等特性，稍有差池效果都将大打折扣。例如拿已广泛应用的指纹识别来说，验证指纹势必要求司机把手指伸至车窗外，干扰正常驾驶且体验感极差；亦或是现今热门的人脸识别，在1：N的识别场景下误识率高，再加上处于光源不稳定的室外条件，识别性能极不稳定，安全性难以保障；至于指静脉和步态等其他方式，缺陷则愈加明显，总不可能为了查验身份，让驾驶员下车把个脉或是走两步吧？",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20180711/3.jpg"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "综合考量，最佳选择还是精准度仅次于DNA检测的虹膜识别技术。虹膜作为人体最独特结构之一，位于瞳孔外环形区域，被透明角膜层覆盖，呈现出复杂的放射状纹理。虹膜自胎儿发育阶段形成后直至死亡终生不变，不因外部干扰而磨损变化，具有极强的唯一性和稳定性。通过虹膜识别，同卵双胞胎也能在1s内进行区分，误识率可低至千万分之一。虹膜更无需紧贴采集装置，无需下车就能获取合格图像，完美满足兼容车牌识别的每一个严苛需求。",
            },
            {
                type: "title",
                inner: "远距离虹膜识别：难攻的技术堡垒",
            },
            {
                type: "text",
                inner:
                    "尽管从理论角度出发，虹膜识别技术是车牌识别的不二之选，但车牌识别发展至今，仍未能在应用层面与虹膜识别技术相结合。究其原因，就在于市面上的大多数虹膜识别设备都未攻破工作距离这道技术堡垒，限制了二者更深层次的合作。",
            },
            {
                type: "text",
                inner:
                    "目前国内市场上的虹膜识别设备，多为近距离虹膜识别产品，工作距离不足40cm，需用户主动配合设备方能完成图像采集，这对于人在车内驾驶座上的司机来说，无疑体验不佳；二、由于研发生产成本高昂，其他虹膜识别设备成本至少在几万元以上，这对于走成本控制路线的车牌识别系统而言，价格高昂令人望而却步。而拥有世界上规模最大的远距离虹膜识别研究团队的虹星科技，目前则已成功攻克了这些难题",
            },
            {
                type: "text",
                inner:
                    "在识别距离上，虹星科技已研发出批量成熟的远距离虹膜融合识别产品系列，识别距离达0.8-1.2米，为传统虹膜识别距离的4倍，简化了用户肢体配合步骤，极大提升了操作体验感。与此同时，虹星科技还研发出工作距离长达10米的虹膜识别技术，即将在下半年推出系列产品小规模向市场供应。",
            },
            {
                type: "title",
                inner: "虹星科技：“眼球经济”前沿探索者",
            },
            {
                type: "text",
                inner:
                    "作为中科院自动化研究所在人工智能领域孵育的一家高科技企业，虹星科技是中国将虹膜融合识别投入商业应用的创新型高新技术公司，在国内率先推出商业化远距离虹膜融合识别产品及解决方案，采用人脸融合+活体检测技术，识别全程控制在2秒内，以千万分之一误识率对亿级规模人群进行高效稳定安全识别。",
            },
            {
                type: "text",
                inner:
                    "虹星科技核心技术团队来源为中科院自动化研究所的模式识别国家重点实验室，拥有20年远距离虹膜识别应用深耕经验和15年视觉成像处理研发管理和实践基础，基于自主研发的远距离虹膜识别和智能三维人机交互两大核心技术，立足光学、电子、数据、AI、处理与云6大版块，提供大规模视觉数据采集、分析和管理的硬件—软件—算法整体解决方案。",
            },
            {
                type: "text",
                inner:
                    "除去全自主研发的技术软实力，虹星科技在硬件上也巧妙设计了独有的多摄相机矩阵，通过多维度采集而后形成立体三维图像，打破传统二维平面拍摄模式，并追加TOF相机镜头，通过感知景深摄像头和运动追踪摄像头，感知周围物体的尺寸，实时监测识别对象位置和方向，助力远距离虹膜技术，为用户带来极佳的人性化体验。公司主要产品有W200手持式虹膜人脸信息注册采集设备、S200标准版混合生物特征识别一体机、S200G“人证+活体+虹膜”防暴防冲撞智能闸机等产品，目前已与金融、互联网、零售、教育、房地产等行业建立合作关系。",
            },
            {
                type: "title",
                inner: "智能出行：虹膜识别颠覆旧认知",
            },
            {
                type: "text",
                inner:
                    "如今既然拥有了成熟的远距离虹膜融合识别产品，那么真正做到人车合一的车牌识别+人体识别的多模态识别车辆管理系统将不再是纸上谈兵。不仅如此，这个全新智慧车辆管理系统势必造福数千万级别的广大车友群体，汽车广告中常提起的无拘无束、自由出行的时代将真正来临。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20180711/4.jpg"),
                desc: "图 | 虹膜人脸+车牌识别将引领新出行时代",
            },
            {
                type: "text",
                inner:
                    "当车辆进入采用全新智慧车辆管理系统的停车场时，全程都无需下车，两秒内就能自动完成车牌+识别双重识别工作，自动放行自动缴费，更可开启预警机制，提升管理效率同时保证体验度与安全性。在高速公路出入口，车主通过收费口也无需出示手机或卡票，直接完成扣费，实现无感支付快速通行，甚至自动加油扣费、购物记录抵换停车劵、消费零感支付也可轻松实现。",
            },
            {
                type: "text",
                inner:
                    "对机场、港口或车站等大规模人群交通枢纽来说，虹膜技术也将促成乘客无证通行的崭新局面：乘客只需利用虹膜识别自助设备，就能完成自助取票、自助值机多种服务。一双眼睛容万物，届时身份信息、票务信息尽在眼中，轻轻一瞥便可随心所欲。",
            },
            {
                type: "text",
                inner:
                    "边境检查、关卡检查上，业务中引入虹膜识别无异于如虎添翼，不但能建立庞大人群混合生物特征数据库，依照民族、地域、犯罪史等类别进行各类划分，在人口聚集地对出入人口进行个体身份识别，掌控敏感人群动向，筑牢防控风险，确保大局稳定。",
            },
            {
                type: "text",
                inner:
                    "未来已来，相信随着远距离虹膜融合识别产品系列的不断完善升级，虹星科技在生物识别领域还将有更多新的尝试和突破，实践将自由出行服务带给每个人、每个家庭、每个组织的承诺，真正架起企业与消费者、科技产品与智能生活沟通的桥梁。这簇不容小觑的星星之火，将渐成眼球经济里的燎原之势。",
            },
        ],
    },
    {
        imgPo: "imgLeft",
        img: require("@/assets/img/news/20200716/01.png"),
        title:
            "Deepen the cooperation between school and enterprise",
        desc:
            "Recently, Hongxing technology and the school of artificial intelligence of Shenzhen Vocational and technical college have reached a cooperation agreement on jointly building an internship base. The two sides will integrate their own advantageous resources, carry out in-depth cooperation around the cultivation of Applied Talents in the artificial intelligence industry, and jointly build a new benchmark for the integration of production and learning of artificial intelligence.",
        time: "2020.06.30", // 时间
        content: [
            {
                type: "text",
                inner:
                    "近日，虹星科技与深圳职业技术学院人工智能学院就共建实习基地达成合作协议，双方将整合各自优势资源，围绕人工智能产业应用型人才培养展开深入合作，联手打造人工智能产学融合新标杆。深职院人工智能学院杨金锋院长、南方科技大学张建国教授、于仕琪教授，虹星科技总经理侯广琦博士共同为实习基地揭牌。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20200716/01.png"),
                desc: "“实习基地”揭牌仪式现场",
            },
            {
                type: "text",
                inner:
                    "人工智能作为新一轮产业变革的核心驱动力量，将推动数万亿数字经济转型升级。面对当前复杂形势，中国正加快布局“新基建”，人工智能在各个行业的应用将不断深入，人才的需求也会越来越强烈。",
            },
            {
                type: "text",
                inner:
                    "深职院作为国内最早举办高等职业技术教育的院校，经过27年的发展，在人才培养、产教融合、科学研究等方面取得显著成绩，学校综合实力位居全国第一。作为中国高职院校的“扛旗者”，为应对未来新兴产业和珠三角及深圳产业发展的需要成立了人工智能学院，开设了软件开发、人工智能、大数据、云计算和虚拟现实等前沿学科专业，学院先后被评为全国教育系统先进集体、全国职业院校技能大赛突出贡献单位、深圳市教育先进单位。深职院人工智能学院杨金锋院长表示“虹星科技技术实力雄厚自主创新能力强，实习基地的设立为学院培养人工智能产业应用型人才搭建了更加广阔的平台，有助于在校大学生积累实战经验，为学生高质量就业保驾护航”",
            },
            {
                type: "text",
                inner:
                    "虹星科技是中国科学院自动化研究所在人工智能领域孵育的一家国家级高新技术企业，致力于远距离虹膜人脸融合识别、智能视觉传感器、生物多属性分析、云服务等领域的探索和研发，为智能安防、智慧金融、智能制造等行业提供大规模视觉数据采集、分析和管理的硬件—软件—算法整体解决方案。虹星科技子公司深圳虹星智能有限公司作为虹星科技在深圳设立的子公司，是虹星科技华南区域业务运营中心、供应链管理中心、计算成像多摄模组研发制造基地，承载实习基地的具体运营工作。虹星科技总经理侯广琦博士表示，“此次合作，对虹星科技有着重要意义，是公司在产学研方面的一次里程碑式的跨步，为公司打造和培养适应公司岗位需求和发展的应用型人才打牢了基础，有助于企业快速发展”。",
            },
            {
                type: "text",
                inner:
                    "此次虹星科技与深职院携手共建实习基地，双方将充分发挥在理论、技术、产品、人才、市场等方面的优势，进一步在华南地区深耕人工智能技术创新。当下中国加快布局“新基建”的时代背景下，共同促进生物特征识别、工业视觉检测、新型计算成像模组等前沿技术及应用研发落地的深度合作，加速人工智能产业创新应用型人才的规模化培养，联手打造智能识别与工业视觉技术技能人才的培养高地，助力深圳人工智能产业发展。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20200716/02.png"),
                desc: "领导嘉宾一同参观万级光学研发基地",
            },

            {
                type: "text",
                inner:
                    "揭牌仪式后，虹星科技总经理侯广琦博士与深圳职业技术学院人工智能学院杨金锋院长、南方科技大学张建国教授和于仕琪教授一同参观了虹星科技千级光学研发基地，就生物特征识别产业发展方向、培养人工智能产业创新应用型人才、打造高水平产学研模式、拓展医疗影像技术的创新合作等新技术新方向进行了深入交流，均表示将进一步加强相关领域的交流与合作。",
            },
            {
                type: "text",
                inner:
                    "虹星科技自成立以来，高度重视人才培育，本着“服务社会、优势互补、资源共享、互惠双赢”的原则，先后与中国科学院自动化研究所、北京理工大学、天津大学、天津科技大学等高校签订了多种创新性人才培养合作协议。每年为生物特征识别、工业视觉检测、计算成像等人工智能专业的大学生提供实践平台，成为诸多高校的“校外课堂”，为学院培养人工智能产业应用型人才搭建了更加广阔的平台，充分发挥了实习基地的社会服务和辐射功能，同时也为大学生实习、实训提供了更多空间。",
            },
        ],
    },
    {
        imgPo: "imgLeft",
        img: require("@/assets/img/news/20200525/01.png"),
        title: "Iristar won the title of \"ZhongGuanCun golden seed enterprise\"",
        desc:
            "The official website of Zhongguancun National Independent Innovation Demonstration Zone released the list of \"the ninth batch of Zhongguancun golden seed enterprises\". Beijing Zhongke Hongxing Technology Co., Ltd., as the pioneer of \"remote iris recognition and iris face fusion recognition\", won the title of \"ZhongGuanCun golden seed enterprise\".",
        time: "2020.05.25",
        content: [
            {
                type: "text",
                inner:
                    "中关村国家自主创新示范区官网发布了“第九批中关村金种子企业”名单，北京中科虹星科技有限公司作为“远距离虹膜识别和虹膜人脸融合识别”的先行者荣获“中关村金种子企业”称号。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20200525/01.png"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "“金种子企业”是指在战略性新兴产业领域，在技术水平、商业模式、创新能力、创业团队和治理结构等方面表现出较强发展潜力的初创企业。“金种子工程”定期发布“金种子企业”名单，旨在传承中关村企业家精神，弘扬中关村创新创业文化，培育一批“金种子企业”、聚集一批创业导师、吸引一批天使投资人、整合一批创业服务机构，为入选企业提供创业辅导与培训、交流沟通与合作、空间拓展与选址、项目推介与融资等专业化服务。",
            },
            {
                type: "text",
                inner:
                    "虹星科技作为一家技术驱动创新型企业，自创立之日起，坚持自主创新，创始团队源自于中科院自动化所，积极引进并培养高素质技术人才，持续推进虹膜识别研究开发与技术成果转化。到目前为止，虹星科技共形成50余项核心自主知识产权，进一步提升在虹膜识别领域的核心竞争力，在创新发展道路上起到优秀示范作用，接连被认定为“国家高新技术企业”“中关村高新技术企业“”天津市高新技术企业“”天津市技术领先型企业“”天津市首批瞪羚企业卓越创新奖“”天津经开区十佳瞪羚企业“”国际ISO9001认证企业”等。此次殊荣是中关村国家自主创新示范区对虹星科技的高度认可。虹星科技创始人侯广琦博士表示：“荣获金种子企业认证是虹星科技发展过程中一个重要的里程碑，公司将进一步加强技术创新和科技成果转化能力，为企业持续、健康、快速发展提供强有力的支撑。”",
            },
            {
                type: "title",
                inner: "虹星科技",
                align: "center",
                style: "margin-top:.5rem",
            },
            {
                type: "text",
                inner:
                    "虹星科技是中国科学院自动化研究所在人工智能领域孵育的一家国家级高新技术企业，以打造通行世界的身份钥匙为己任，致力于远距离虹膜人脸融合识别、智能视觉传感器、生物多属性分析、云服务等领域的探索和研发，为智能安防、智慧金融、智能制造等行业提供大规模视觉数据采集、分析和管理的硬件—软件—算法整体解决方案。",
            },
            {
                type: "text",
                inner:
                    "虹星科技是虹膜融合识别技术商业化的先行者，基于自主研发的远距离虹膜识别和智能三维人机交互两大核心技术，率先推出国内商业化远距离虹膜识别产品，实现了适用于大规模人群下的具有鲁棒三维活体检测的高精度身份认证。公司以BS作为底层架构，开发了先进的虹膜建库管理云平台和智慧识别系统云平台，成为人员能追溯、数据可信赖、设备有监管的整体统一化管理平台。",
            },
            {
                type: "text",
                inner:
                    "虹星科技总部位于天津，在北京、深圳、济南、乌鲁木齐等地设立分支机构，组建了国内庞大的远距离虹膜识别团队，创始团队源于中科院自动化所模式识别国家重点实验室，拥有10年以上远距离虹膜识别应用深耕经验，15年以上视觉成像处理研发管理和实践基础，主持多项国家重点研发计划、863计划、973计划和基金委重大仪器专项等国家级重大科研项目，是国内领先的涵盖光学、电子、软件、算法等学科的远距离虹膜识别研究和开发团队，拥有包括图像ISP、物体检测、人脸检测、关键点定位、深度估计、三维重建、虹膜识别、活体检测等技术领域的50多项核心发明专利和软件著作权，曾获国家技术发明奖、国家科技进步奖，在国际虹膜识别算法公开竞赛NICE.I和NICE.II中两度夺冠。",
            },
        ],
    },
    {
        imgPo: "imgLeft",
        img: require("@/assets/img/news/20200623/01.png"),
        title: "Iristar wins the registration certificate of biometric recognition institution, and the development of facial multimodal fusion recognition is on the fast track",
        desc:
            "Recently, Hongxing technology, which focuses on long-distance iris face fusion recognition technology, has again passed the certification of national authoritative institutions, met the registration requirements of biometric recognition institutions, and obtained the unique organization code of biometric recognition, indicating that Hongxing technology has been authorized in many aspects, such as core independent intellectual property rights, technological innovation strength, and transformation ability of scientific and technological achievements.",
        time: "2020.06.23",
        content: [
            {
                type: "text",
                inner:
                    "近日，专注于远距离虹膜人脸融合识别技术的虹星科技经再次通过国家权威机构认证，符合生物特征识别机构注册要求，获得了生物特征识别唯一机构代码，表明虹星科技在核心自主知识产权、技术创新实力、科技成果转化能力等多方面得到权威认可。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20200623/01.png"),
                size: "small",
                desc: "",
            },
            {
                type: "text",
                inner:
                    "生物特征识别技术是目前在工业界中得到广泛应用的人工智能技术之一，它结合计算机与光学、声学、生物传感器和生物统计学原理等，依靠人体的身体特征来进行身份验证的识别。为了规范生物特征识别产品的生产活动、保障生物特征识别系统互联互通，促进生物特征识别产业持续健康发展，我国正式启用了生物特征识别产品注册管理办法。生物特征识别注册服务不仅能够规范生物特征识别市场秩序，增强我国生物特征识别产品的国际竞争力，同时也有利于我国生物特征识别企业更好地利用国际资源，吸收国际新技术，促进我国生物特征识别产业的快速发展。",
            },
            {
                type: "text",
                inner:
                    "生物特征识别标准的制定需要关键技术的支撑，产业技术水平的高低直接决定了标准的竞争力。《生物特征识别机构注册证书》是对生物特征识别技术和应用、自主知识产权的权威肯定，此认证条件复杂、标准严格、程序严谨。",
            },
            {
                type: "text",
                inner:
                    "虹星科技作为中国科学院自动化研究所在人工智能领域孵育的一家国家级高新技术企业，其创始团队源于中科院自动化所模式识别国家重点实验室，拥有10年以上远距离虹膜识别应用深耕经验，15年以上视觉成像处理研发管理和实践基础，先后研发了W200手持式虹膜人脸信息采集设备、S300-UC面部生物特征身份识别仪、S320壁挂式混合生物特征识别一体机、S320-T虹膜识别温度监测一体机、S210G/S320G系列“虹膜识别+活体检测+人证比对”三合一智能闸机、S200混合生物特征识别一体机、S200P混合生物特征识别一体机、S260P驾驶员身份识别一体机、IriSign全球领先的虹膜加密认证U盘、S300-KQ虹膜人脸识别一体化模组、M300B USB嵌入式面部生物特征采集模组等一系列多模态生物特征识别产品，获得多项软件著作权，积累了过硬的技术创新实力，顺利通过《生物特征识别机构注册证书》认定管理工作领导小组评审。",
            },
            {
                type: "text",
                inner:
                    "虹星科技一直高度重视技术研发创新及知识产权保护，在图像ISP、物体检测、人脸检测、关键点定位、深度估计、三维重建、虹膜识别、活体检测等领域不懈探索，截止目前，现已获得50多项核心发明专利和软件著作权。此次获得《生物特征识别机构注册证书》认证，也是对虹星科技的核心自主知识产权、科技成果转化能力等多方面的权威认可。",
            },
            {
                type: "text",
                inner:
                    "虹星科技此次获颁《生物特征识别机构注册证书》，是虹星科技发展过程中的又一重要里程碑，为虹星科技在日后争取政府政策扶持，提升品牌形象、提高市场价值与资本价值，乃至对虹星科技未来的发展都有着极为重要的积极推动作用。荣获《生物特征识别机构注册证书》后，公司将进一步加强自主知识产权的技术创新、科技成果转化和相关问题的研究，为实现自主技术的标准化，促进生物特征识别领域应用标准的研究和制订，助力打造满足大规模应用的低成本、规模化的生物特征识别产业链。加快国际标准化工作，争取国际话语权贡献自己的力量，全力推动我国生物特征识别产业发展。",
            },
            {
                type: "text",
                inner:
                    "同时，虹星科技也将持续以客户需求为导向，向广大客户提供多样化、高品质、专业化的面部多模态融合识别软硬件一体化解决方案，在生物特征识别应用迈入快车道的当下，为面部多模态融合识别发展的智能化普及和商业化提升做出贡献，致力于成为全球范围内精准面部融合识别的领跑者。",
            },
        ],
    },
    {
        imgPo: "imgLeft",
        img: require("@/assets/img/news/20200713/20200713.png"),
        title: "CCTV1 \"life circle\" | new technology of Zhongke Hongxing intelligent travel, academicians come to decrypt!",
        desc:
            "Recently, in order to create a new era of intelligent travel, the s260p driver identification machine developed by China Science and technology Hongxing was interviewed and reported by CCTV1 integrated channel morning section \"life circle\". ",
        time: "2020.07.23",
        content: [
            {
                type: "text",
                inner:
                    "近日， 中科虹星为开创智慧出行新时代重点研发的驾驶员身份识别一体机S260P受到CCTV1综合频道早间板块《生活圈》的视频采访报道。中国科学院谭铁牛院士和中国科学院自动化研究所孙哲南研究员介绍了这项新科技产品的原理、特点及使用场景。",
            },
            {
                type: "title",
                align: "center",
                inner: "院士说科技",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20200713/20200713-2.png"),
                // size:'small',
                desc: "",
            },
            {
                type: "text",
                inner:
                    "<b>中国科学院谭铁牛院士表示</b>，虹膜识别技术是一种相对比较新颖的生物特征识别技术，下一步虹膜识别技术会进一步朝着移动化、便捷化以及和其它相关的生物特征识别技术（比如人脸识别技术）相融合的方向发展，具有非常广阔的发展空间。",
            },
            {
                type: "title",
                inner: "虹膜识别：智慧出行最优选",
                align: "center",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20200713/20200713-3.png"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "虹膜识别是利用人眼表面黑色瞳孔和白色巩膜之间圆环状的区域进行身份识别。虹膜识别的优势在于：",
            },
            {
                type: "text",
                inner:
                    "<b>第一，虹膜先天具有非常高的唯一性。</b>因为它的形成的过程是母体胚胎发育的随机环境,导致每个人的虹膜都是独一无二的，即使是双胞胎虹膜也不一样。虹膜的先天优势是它的信息量比人脸和指纹高一个数量级，虹膜至少244个独立的变量来决定它的唯一性，而指纹和人脸大概只有十几个或者几十个这样的变量。",
            },
            {
                type: "text",
                inner:
                    "<b>第二，虹膜终身不变。</b>容貌容易随着年龄的增长、化妆或者整容发生改变，指纹容易受到皮肤的摩擦、油渍污渍的影响使用失效。虹膜是非接触式采集，非常稳定不变。",
            },
            {
                type: "title",
                align: "center",
                inner: "虹膜识别：智慧出行颠覆认知",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20200713/20200713-4.png"),
                desc: "",
            },
            {
                type: "text",
                inner:
                    "中科虹星为智慧出行重点研发的驾驶员身份识别产品，是针对目前国内汽车出入及停车安全服务，进行开创性的改造与升级的全新成果，可与车牌识别设备结合，实现人车一体化识别，有效解决了当前车牌识别系统所遇到的难题。",
            },
            {
                type: "text",
                inner:
                    "<b>孙哲南研究员表示：</b>驾驶员生物特征识别一体机S260P是一套基于虹膜识别的驾驶员身份验证系统，它的特点就是驾驶员不用下车可以在车上完成身份认证，将来我们可以把这个系统用在ETC(电子不停车收费系统)、高速公路上，我们不需要刷我们的卡，也不需要我们其他的身份认证手段，直接通过眼神识别可以进行ETC（电子不停车收费系统）的收费，这样的话它就非常便捷、非常安全可靠。",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20200713/20200713-5.png"),
                desc: "",
            },
            {
                type: "img",
                inner: require("@/assets/img/news/20200713/20200713-6.png"),
                desc: "",
            },
            {
                type: "title",
                align: "center",
                inner:
                    "远距离虹膜识别是驾驶员驾车出入时无需下车摇下车窗就能完成个人身份验证的关键。",
            },
            {
                type: "text",
                inner:
                    "目前国内市场上的虹膜识别设备，多为中近距离的虹膜识别产品，其工作距离在40-60cm之间，需要驾驶员主动配合靠近设备完成图像的采集，这就很难在应用层面与车牌识别相结合。中科虹星凭借着在中国科学院自动化研究所十多年的远距离虹膜识别研究的技术积淀与多项国家相关重点项目课题的产研经验，已研发出了成熟的远距离虹膜融合识别系列产品，识别距离达1.2米，更采用虹膜人脸融合+活体检测技术，识别全程控制在2秒内，以百万分之一误识率对亿级规模人群进行高效稳定安全识别，其自主研发的远距离虹膜识别技术曾被《科技日报》评为“2018年中国十大突破技术”。该技术与车牌识别技术的结合可以确保驾驶员在驾车出入时，无需下车仅摇下车窗就能完成车辆与个人身份的双重验证，确保用户在驾驶车辆过程中得到最严密的安全保障。",
            },
            {
                type: "text",
                inner:
                    "中科虹星作为一家技术驱动创新型企业，时刻谨记着谭铁牛院士在鼓励团队创业，支持中科虹星带着所内前沿的科研成果走向民生，在市场中积累实践经验与改进技术产品的教诲，不断完善远距离虹膜融合产品系列，坚持自创创新，开创智能出行、无证通行新时代。",
            },
            {
                type: "video",
                inner: require("@/assets/img/news/20200713/shenghuoquan.mp4"),
            },
        ],
    },
    {
        imgPo: "imgLeft",
        img: require("@/assets/img/news/20200810/20200810.png"),
        title: "Ji Guoqiang, member of the Standing Committee of the CPC Tianjin Municipal Committee and head of the United Front Work Department",
        time: "2020.08.10",
        desc:
            "On August 7, Ji Guoqiang, member of the Standing Committee of Tianjin municipal Party committee and director of the United Front Work Department of Tianjin municipal Party committee, led a team to Hongxing technology to carry out special investigation and Discussion on the key and difficult points encountered in the development of private science and technology enterprises. He stressed that time does not wait for us to build a world science and technology power.",
        content: [
            {
                type: "text",
                inner:
                    "8月7日，天津市委常委、市委统战部部长冀国强带队莅临虹星科技，就民营科技型企业发展遇到的重点难点开展专题调研并进行座谈。他强调，建设世界科技强国时不我待，要坚持国产化发展、坚持自主创新、坚持技术转化，表示天津政府、新区政府会竭尽全力服务好每一家科技型企业，为企业提供和创造良好的营商环境。",
            },
            {
                type: "img",
                align: "center",
                inner: require("@/assets/img/news/20200810/20200810.png"),
                desc: "天津市委常委、统战部部长冀国强带队调研虹星科技",
            },
            {
                type: "text",
                inner:
                    "虹星科技总监李海青博士向冀国强部长及陪同领导介绍了虹星科技团队从中国科学院自动化研究所起源、到中科智能产业识别研究院孵化、再到经开区落地转化的整个发展历程。调研团在展厅体验了远距离虹膜识别、虹膜人脸融合识别等一系列自主创新技术产品，对于公司高科技产品在边检、工地、智慧社区等领域的运用表示充分的肯定。",
            },
            {
                type: "img",
                align: "center",
                inner: require("@/assets/img/news/20200810/20200810-1.png"),
                desc: "冀国强一行听取汇报",
            },
            {
                type: "text",
                inner:
                    "座谈会上，李海青博士详细介绍了虹星科技三个工作重点：第一，利用生物特征识别技术和大数据可视化技术提高社会治理智能化水平；第二，基于计算机视觉和大数据分析技术提高工业制造智能化水平；第三，利用天津在国产操作系统与国产芯片的产业优势，推动虹星科技产品在国家、人民安全保障工作中发挥更大作用。冀部长基于对虹星科技工作重点的认可，就如何更好地打开天津乃至全国市场提出了自己的建议。",
            },
            {
                type: "text",
                inner:
                    "市委统战部副部长、市工商联党组书记王禹，天津滨海新区区委统战部部长费巍，滨海新区区委组织部副巡视员张青，市委统战部办公室主任王文忠，市委统战部四处处长李东，市委统战部网信办主任徐金霞等同志陪同调研。",
            },
        ],
    },
    {
        imgPo: "imgLeft",
        img: require("@/assets/img/news/20200818/01.png"),
        title: "Zheng Xiangling, President of Zhengda Pharmaceutical Group and Luo Fei, chairman of Songhe capital visited Hongxing Technology",
        time: "2020.08.18",
        desc:
            "On August 17, Zheng Xiangling, President of Zhengda Pharmaceutical Group, and Luo Fei, chairman of Songhe capital, visited Hongxing technology, an industrialized company incubated by Institute of automation, Chinese Academy of Sciences.",
        content: [
            {
                type: "text",
                inner:
                    "8月17日，正大制药集团总裁郑翔玲、松禾资本董事长罗飞一行莅临中国科学院自动化研究所孵化的产业化公司虹星科技考察指导。",
            },
            {
                type: "img",
                align: "center",
                inner: require("@/assets/img/news/20200818/01.png"),
                desc: "正大制药集团总裁郑翔玲、松禾资本董事长罗飞一行参观考察",
            },
            {
                type: "text",
                inner:
                    "研发总监李海青博士向来宾介绍了虹星科技发展历程、团队情况、业务进展、研发近况，着重介绍了虹星科技多年来在远距离虹膜识别、虹膜人脸融合识别领域深耕所取得的成果，以及自主创新研发产品在大规模人群身份识别中的场景落地应用。",
            },
            {
                type: "img",
                align: "center",
                inner: require("@/assets/img/news/20200818/02.png"),
                desc: "正大制药集团总裁郑翔玲一行参观展厅",
            },
            {
                type: "text",
                inner:
                    "正大制药集团总裁郑翔玲肯定了中国科学院自动化研究所集聚人工智能高端人才，在虹膜识别领域深耕20余年，始终走在科技创新和技术应用的最前沿。她指出，虹星科技作为中国科学院自动化研究所孵化的一家创新型科技企业，对公司在短时间内所取得的成就和业绩表示赞许。",
            },
            {
                type: "text",
                inner:
                    "展厅参观期间，双方进一步探讨了虹膜识别在金融、医疗等行业的应用，沟通了公司的融资情况。李海青博士表示，公司近期将会启动新一轮的融资。郑翔玲总裁和罗飞董事长均认为，在新冠肺炎疫情的影响下，虹膜识别必将在社会生活中发挥越来越大的作用，表示会进一步加强企业间的交流与合作。",
            },
            {
                type: "text",
                inner:
                    "中国科学院自动化研究所模式识别国家重点实验室副主任、智能感知与计算研究中心的常务副主任王亮研究员、正大天晴药业集团股份有限公司药物研究院副院长张寅生博士、北京泰德制药股份有限公司等相关人员陪同参观。",
            },
        ],
    },
    {
        imgPo: "imgLeft",
        img: require("@/assets/img/news/20201111/01.jpg"),
        title: "Hi Tech fair invites iristar to present a variety of iris face fusion recognition products, looking forward to your presence!",
        time: "2020.11.11",
        desc: "",
        content: [
            {
                type: "img",
                align: "center",
                inner: require("@/assets/img/news/20201111/01.jpg"),
                desc: "",
            },
        ],
    },
];

// 给每一项添加唯一id
const addId = () => {
    for (let i = 0; i < newsList.length; i++) {
        newsList[i].id = i + 1;
    }
};
addId();

// 按时间排序
const sortByTime = (a, b) => {
    // 1, 降序; 0, 升序
    let type = 1;
    if (type === 1) {
        return new Date(b.time) - new Date(a.time);
    }
    if (type === 0) {
        return new Date(a.time) - new Date(b.time);
    }
};
export default newsList.sort(sortByTime);
